(function (lib, img, cjs, ss, an) {

var p; // shortcut to reference prototypes
lib.ssMetadata = [
		{name:"MWpig_atlas_", frames: [[0,0,208,208],[0,210,176,176],[76,660,68,132],[146,660,68,132],[218,576,80,166],[418,452,80,166],[108,532,108,126],[308,528,108,126],[0,524,106,130],[308,396,106,130],[112,396,110,134],[0,388,110,134],[300,656,74,148],[0,656,74,148],[224,396,82,178],[428,272,82,178],[418,620,94,118],[460,0,44,50],[460,52,36,52],[376,740,60,50],[210,138,250,132],[178,272,248,122],[210,0,248,136]]}
];


// symbols:



(lib.M_Wash_Bubble = function() {
	this.spriteSheet = ss["MWpig_atlas_"];
	this.gotoAndStop(0);
}).prototype = p = new cjs.Sprite();



(lib.M_Wash_Bubble_pop = function() {
	this.spriteSheet = ss["MWpig_atlas_"];
	this.gotoAndStop(1);
}).prototype = p = new cjs.Sprite();



(lib.PigFrontLegBack0001 = function() {
	this.spriteSheet = ss["MWpig_atlas_"];
	this.gotoAndStop(2);
}).prototype = p = new cjs.Sprite();



(lib.PigFrontLegBack0002 = function() {
	this.spriteSheet = ss["MWpig_atlas_"];
	this.gotoAndStop(3);
}).prototype = p = new cjs.Sprite();



(lib.PigFrontLeg0001 = function() {
	this.spriteSheet = ss["MWpig_atlas_"];
	this.gotoAndStop(4);
}).prototype = p = new cjs.Sprite();



(lib.PigFrontLeg0002 = function() {
	this.spriteSheet = ss["MWpig_atlas_"];
	this.gotoAndStop(5);
}).prototype = p = new cjs.Sprite();



(lib.PigHead_0010001 = function() {
	this.spriteSheet = ss["MWpig_atlas_"];
	this.gotoAndStop(6);
}).prototype = p = new cjs.Sprite();



(lib.PigHead_0010002 = function() {
	this.spriteSheet = ss["MWpig_atlas_"];
	this.gotoAndStop(7);
}).prototype = p = new cjs.Sprite();



(lib.PigHead_0030001 = function() {
	this.spriteSheet = ss["MWpig_atlas_"];
	this.gotoAndStop(8);
}).prototype = p = new cjs.Sprite();



(lib.PigHead_0030002 = function() {
	this.spriteSheet = ss["MWpig_atlas_"];
	this.gotoAndStop(9);
}).prototype = p = new cjs.Sprite();



(lib.PigHead_0050001 = function() {
	this.spriteSheet = ss["MWpig_atlas_"];
	this.gotoAndStop(10);
}).prototype = p = new cjs.Sprite();



(lib.PigHead_0050002 = function() {
	this.spriteSheet = ss["MWpig_atlas_"];
	this.gotoAndStop(11);
}).prototype = p = new cjs.Sprite();



(lib.PigHindLegBack0001 = function() {
	this.spriteSheet = ss["MWpig_atlas_"];
	this.gotoAndStop(12);
}).prototype = p = new cjs.Sprite();



(lib.PigHindLegBack0002 = function() {
	this.spriteSheet = ss["MWpig_atlas_"];
	this.gotoAndStop(13);
}).prototype = p = new cjs.Sprite();



(lib.PigHindLeg0001 = function() {
	this.spriteSheet = ss["MWpig_atlas_"];
	this.gotoAndStop(14);
}).prototype = p = new cjs.Sprite();



(lib.PigHindLeg0002 = function() {
	this.spriteSheet = ss["MWpig_atlas_"];
	this.gotoAndStop(15);
}).prototype = p = new cjs.Sprite();



(lib.PigNeck0001 = function() {
	this.spriteSheet = ss["MWpig_atlas_"];
	this.gotoAndStop(16);
}).prototype = p = new cjs.Sprite();



(lib.PigTail20001 = function() {
	this.spriteSheet = ss["MWpig_atlas_"];
	this.gotoAndStop(17);
}).prototype = p = new cjs.Sprite();



(lib.PigTail_excited_0020001 = function() {
	this.spriteSheet = ss["MWpig_atlas_"];
	this.gotoAndStop(18);
}).prototype = p = new cjs.Sprite();



(lib.PigTail_excited_0030001 = function() {
	this.spriteSheet = ss["MWpig_atlas_"];
	this.gotoAndStop(19);
}).prototype = p = new cjs.Sprite();



(lib.PigTorso0002 = function() {
	this.spriteSheet = ss["MWpig_atlas_"];
	this.gotoAndStop(20);
}).prototype = p = new cjs.Sprite();



(lib.PigTorso_excited_0020001 = function() {
	this.spriteSheet = ss["MWpig_atlas_"];
	this.gotoAndStop(21);
}).prototype = p = new cjs.Sprite();



(lib.PigTorso_excited_0030001 = function() {
	this.spriteSheet = ss["MWpig_atlas_"];
	this.gotoAndStop(22);
}).prototype = p = new cjs.Sprite();
// helper functions:

function mc_symbol_clone() {
	var clone = this._cloneProps(new this.constructor(this.mode, this.startPosition, this.loop));
	clone.gotoAndStop(this.currentFrame);
	clone.paused = this.paused;
	clone.framerate = this.framerate;
	return clone;
}

function getMCSymbolPrototype(symbol, nominalBounds, frameBounds) {
	var prototype = cjs.extend(symbol, cjs.MovieClip);
	prototype.clone = mc_symbol_clone;
	prototype.nominalBounds = nominalBounds;
	prototype.frameBounds = frameBounds;
	return prototype;
	}


(lib.Wet_drop = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer 1
	this.shape = new cjs.Shape();
	this.shape.graphics.f("#91D6F7").s().p("AgeBSQgPgSgCgjQgCgiAkheQA2BhAFAgQAFAkgOARQgOARgUAAQgTAAgOgSg");
	this.shape.setTransform(4.8,10);

	this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(0,0,9.6,20);


(lib.SmallStar = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer 1
	this.shape = new cjs.Shape();
	this.shape.graphics.f("#FFFF99").s().p("Ag1BSQgGgDAFgaIAHgaIgVgVQgVgUADgFQACgFAbgFIAbgFIAMgYQAOgYAEAAQAHAAAYAyIAbADQAbAEACAGQAEAJgtAlQAPAzgHAEQgHAEgvgaQgkAXgNAAIgEgBg");

	this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-8.7,-8.3,17.6,16.7);


(lib.LargeStar = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer 1
	this.shape = new cjs.Shape();
	this.shape.graphics.f("#FFFF99").s().p("AhGBuQgJgFAHgjIAJgiIgcgbQgbgcADgGQADgHAkgHIAjgGIARggQATghAFABQAKgBAgBDIAjAEQAkAGADAIQAFAMg7AxQAUBEgKAGQgKAFg+gjQgwAegRAAIgFAAg");

	this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-11.6,-11,23.4,22.1);


(lib.sparkle = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer 1
	this.shape = new cjs.Shape();
	this.shape.graphics.f("#FFFFFF").s().p("AgZAGQAYgRABg2QACA2AYANQgWAVgDArQgIgxgSgLg");
	this.shape.setTransform(-0.1,1);

	this.shape_1 = new cjs.Shape();
	this.shape_1.graphics.f("#FFFFFF").s().p("AggAkQgLgQgMgHQANgKAKgOQAdgsADhXQAEBYAeAoQAJAMAMAHIABAAQgNALgJAQQgaApgFBFIAAABQgNhJgWgig");
	this.shape_1.setTransform(-0.1,1);

	this.shape_2 = new cjs.Shape();
	this.shape_2.graphics.f("#FFFFFF").s().p("AgyA5QgQgZgTgMQAUgPAPgWQAthEAFiHQAGCJAvA9QAOAUASAKQgSASgOAYQgpBAgHBrQgVhwgig0gAgZAGQASALAIAxQAEgsAVgUQgYgNgCg3QgBA3gYARg");
	this.shape_2.setTransform(-0.1,1);

	this.shape_3 = new cjs.Shape();
	this.shape_3.graphics.f("#FFFFFF").s().p("Ag0BYQA1AmAzgmQgnBAgHBqQgWh2gkg0gAhxAKQATgNAPgYQgVAlAVAlQgQgZgSgMgABRgfQAOATATALQgTARgOAYQAUglgUgigAgrhAQAnhDAEh9QAHCDAqA9QgugpguApg");
	this.shape_3.setTransform(-0.2,2);

	this.shape_4 = new cjs.Shape();
	this.shape_4.graphics.f("#FFFFFF").s().p("AgMC8QAQAaAOgaQgIAlgEAtQgHgugLgkgAh7ALIASgPQgMARALAMQgIgJgJgFgABvgJIANAJIgNAMQAIgMgIgJgAgJisQAIgrABg2QADA3AJAqQgLgOgKAOg");
	this.shape_4.setTransform(-0.3,1.9);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.shape}]}).to({state:[{t:this.shape_1}]},1).to({state:[{t:this.shape_2}]},1).to({state:[{t:this.shape_3}]},1).to({state:[{t:this.shape_4}]},1).to({state:[]},1).wait(45));

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-2.7,-5.7,5.2,13.3);


(lib.PigTail2 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer 3
	this.instance = new lib.PigTail20001();
	this.instance.parent = this;
	this.instance.setTransform(2.2,-7,0.5,0.5);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(2));

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(2.2,-7,22,25);


(lib.PigTail_excited_003 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer 2
	this.instance = new lib.PigTail_excited_0030001();
	this.instance.parent = this;
	this.instance.setTransform(-5.2,-7.5,0.5,0.5);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(2));

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-5.2,-7.5,30,25);


(lib.PigTail_excited_002 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer 3
	this.instance = new lib.PigTail_excited_0020001();
	this.instance.parent = this;
	this.instance.setTransform(6,-8.8,0.5,0.5);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(2));

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(6,-8.8,18,26);


(lib.pig_tummyGlow = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer 1
	this.shape = new cjs.Shape();
	this.shape.graphics.f().s("#FFFF00").ss(4,1,1).p("AFwh1QiHg2i7gRQiOgGheAJQjnAfg2AlQgXAPgEAYQgBAEAAArQAAAOAOAgQASAoAaAhQAIAKAIAKQAJATASAOQBBAxC1ACIDegHQBQgEAmgIQDBgUBKg0QA1gmAAhDQAAg6iIg3g");
	this.shape.setTransform(50.4,19.1);

	this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

}).prototype = getMCSymbolPrototype(lib.pig_tummyGlow, new cjs.Rectangle(-2,-2,104.9,42.3), null);


(lib.pig_noseMud_003 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{clean:1});

	// timeline functions:
	this.frame_0 = function() {
		/* stop();
		gameVars.noseMud.push(this);
		if (gameVars.noseMudClean == true) {this.alpha = 0;};*/
	}

	// actions tween:
	this.timeline.addTween(cjs.Tween.get(this).call(this.frame_0).wait(2));

	// Layer 1
	this.shape = new cjs.Shape();
	this.shape.graphics.f("rgba(169,114,78,0.8)").s().p("AgkBOQgbgKgFAAIgGAFQgGAFgOgBQgGgBgHgKIgHgOQgLgQAAgRQgBgLADgKQAGgWAVAAQAOAAASAIIADgFQAAgTAVgNQAVgMASAIIAFgIQAFgEAQgBQABgGAIgCIAAAAQAEgDAIABIAKACIAEgEQAIgGAQAJQAQAJAAAHQAXAKAAAXIAAAFQADAJAAAJQABAHgCADIAAABQgEAegcAWQgcAXglAFIgWABQgXAAgTgHg");
	this.shape.setTransform(13.5,8.5);

	this.timeline.addTween(cjs.Tween.get(this.shape).to({_off:true},1).wait(1));

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(0.9,0,25.3,17.1);


(lib.pig_noseMud_002 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{"clean":1});

	// timeline functions:
	this.frame_0 = function() {
		/* stop();
		gameVars.noseMud.push(this);
		if (gameVars.noseMudClean == true) {this.alpha = 0;};*/
	}

	// actions tween:
	this.timeline.addTween(cjs.Tween.get(this).call(this.frame_0).wait(2));

	// Layer 1
	this.shape = new cjs.Shape();
	this.shape.graphics.f("rgba(169,114,78,0.8)").s().p("AhfBAQgagZAOggQAEgHANgIQAOgIAEAFIABgCQABgJAEgCQAIgIAbABIAAAAQABgGAFgIQAIgNANgBIABgDQADgKAMAAIAMACQAOgWARAPQAKAJAPATQAWAQAGALQAFAIAAARQAAAUgXAZQggAjg6AAIgCAAIgGAAIgnAAIgPABIgBAAQgLAAgVgUg");
	this.shape.setTransform(3.1,8.4);

	this.timeline.addTween(cjs.Tween.get(this.shape).to({_off:true},1).wait(1));

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-8.1,0,22.6,16.8);


(lib.pig_noseMud_001 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{mud:0,soap:34,"clean":46});

	// timeline functions:
	this.frame_0 = function() {
		/* gameVars.noseMud.push(this);
		if (gameVars.noseMudClean == true) {this.alpha = 0;};*/
		/* stop();*/
	}
	this.frame_34 = function() {
		/* stop();*/
	}
	this.frame_46 = function() {
		/* stop();*/
	}

	// actions tween:
	this.timeline.addTween(cjs.Tween.get(this).call(this.frame_0).wait(34).call(this.frame_34).wait(12).call(this.frame_46).wait(12));

	// Layer 1
	this.shape = new cjs.Shape();
	this.shape.graphics.f("rgba(169,114,78,0.8)").s().p("AgwBRQghgSgDgOQgDgMgFgKQgDgFAAgKQAAgLACgDQADgJAOgFIAJgOQAIgKAhgCQAshMAjBOQAYACALAJQAIAHAAAIQAAA8hQAjg");
	this.shape.setTransform(9.6,8.1);

	this.timeline.addTween(cjs.Tween.get(this.shape).to({_off:true},22).wait(36));

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(0,0,19.3,16.2);


(lib.pig_noseGlow = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer 1
	this.shape = new cjs.Shape();
	this.shape.graphics.f().s("#FFFF00").ss(4,1,1).p("AB3AcQgQAtgpAXQgMAAgJAEQgIAEghAAQg+AAgjgzQgYgjAAgZQABgFAcgSQAhgUAOgcIATgYQBtgDAkBmQAGAPgGAQg");
	this.shape.setTransform(12.2,13.5);

	this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

}).prototype = getMCSymbolPrototype(lib.pig_noseGlow, new cjs.Rectangle(-2,1.2,28.4,24.7), null);


(lib.pig_legGlow = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer 3
	this.shape = new cjs.Shape();
	this.shape.graphics.f().s("#FFFF00").ss(4,1,1).p("AEjlIQgGAWgBAfQgHC+BVB/IhGAYQAZAhAfAsQAbAsAAA0QAAA2gRA0QgIAagJAZQgDgBgDABQgEABgDACQgBAAgBAAQAAABgBAAQgCACgBACQgJAJgSALQgRAJAAAIQAAAIAJADQABAAABAAIAAAAQAGgBAGgFQAAAAgBABQgBABgEAGQAIAAAEAAQA9AAALgJQABgCADgJQACgJAAgBQAAgEgGgGQALgEAPgKQAcgVAEgTQABgIALgXQAKgVABgIQADgWAaggQAOAlgGAdQgJAygHAdIAAAAQgFAPhCA7QgBABADAFQADAEAFAFQAAAAABABQAVAUAigOQAHgDALgDQAagCAHgGQACgDAEgKQAAgCABgCQAKgMANgSQAEgHAEgGQALgNACgMQADgPAAgWQABgVAAgMQAEgRABgFQAEgQADgMQAHgXAAgIIAEgRQABgNABgEQAHgUAAgVQAAggghgjQAAgEADgCQAIgFASghQAgg0AKgUQA9h1AAhmQAAhKgghAQgqhShTgaQg7gShSAqQg9AfghAmQgWAhgIAggAl5lfQgUgsgsgeQh0hNhFCIQgVArgOA6QgBADgBADQgDAPgCAMQgMARAFBCQABAVAJAgQATBHA/CLIhIAYQACABADAEQAWAUAAAQQAAAYAHAxQAAAPgJAQQgNAWgEAQQgDALgSA3QAAAAAAABQgBABgCACQgJAJgQAKQgQAJAAAHQAAAIAIADQABAAABAAIAAAAQAFgCAHgEQgBAAAAABQgBABgEAGQAHAAAFAAQAOAAAMgBQABAIAIACQABABACAAIAAgBQAGgBAIgGQgBABAAAAQgCACgEAHQAJAAAFAAQBGAAALgLQACgBABgEQA3goAOgaQAGgNAAgXQAAgZACgLQACgQAKgUQAKgUAOgQQAOgOADgVQAAgWACgMQAKhFAshRQAKgQAGgRQAWg0AAgvQAAgCAAgCQAAgagJgzQgJg3gLgaQgLgbgUgkg");
	this.shape.setTransform(-28.5,49.6);

	this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

}).prototype = getMCSymbolPrototype(lib.pig_legGlow, new cjs.Rectangle(-101.8,-1.6,146.6,102.5), null);


(lib.pig_backGlow = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer 1
	this.shape = new cjs.Shape();
	this.shape.graphics.f().s("#FFFF00").ss(4,1,1).p("AG7hzQijg1jhgRQirgHhwAJQkWAfhBAkQgbAQgGAXQgBAEAAArQAAANASAfQAVAoAfAgQAKALAKAJQALATAWAOQBNAwDaACIELgHQBfgEAugHQDogUBZg0QBAglAAhCQAAg6ijg1g");
	this.shape.setTransform(60.6,18.9);

	this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

}).prototype = getMCSymbolPrototype(lib.pig_backGlow, new cjs.Rectangle(-2,-2,125.1,41.8), null);


(lib.M_Wash_Bubble_pop_1 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer 2
	this.instance = new lib.M_Wash_Bubble_pop();
	this.instance.parent = this;
	this.instance.setTransform(-9,-9,0.25,0.25);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	// Layer 1
	this.shape = new cjs.Shape();
	this.shape.graphics.f().s("#FFFFFF").ss(1.9,1,1).p("AAtACIARAAAACg9IAAAUAAgghIAJgMAg9AAIAYgBAgmgrIANAPAgrArIALgNAgEAwIAAAOAAdAoIAKAN");
	this.shape.setTransform(11.2,10.6);

	this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

}).prototype = getMCSymbolPrototype(lib.M_Wash_Bubble_pop_1, new cjs.Rectangle(-9,-9,44,44), null);


(lib.M_Wash_Bubble_1 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer 2
	this.instance = new lib.M_Wash_Bubble();
	this.instance.parent = this;
	this.instance.setTransform(-13,-13,0.25,0.25);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

}).prototype = getMCSymbolPrototype(lib.M_Wash_Bubble_1, new cjs.Rectangle(-13,-13,52,52), null);


(lib.invisiblebox = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer 1
	this.shape = new cjs.Shape();
	this.shape.graphics.f("rgba(255,255,255,0)").s().p("AhwDIIhZgEIAEmHIBOgEIDvAAIBSABIgCGKIhGAEg");
	this.shape.setTransform(-0.3,0);

	this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

}).prototype = getMCSymbolPrototype(lib.invisiblebox, new cjs.Rectangle(-20.5,-20,40.4,40), null);


(lib.blueglowtummy = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer 1
	this.shape = new cjs.Shape();
	this.shape.graphics.f().s("#0099FF").ss(4,1,1).p("AFwh1QiHg2i7gRQiOgGheAJQjnAfg2AlQgXAPgEAYQgBAEAAArQAAAOAOAgQASAoAaAhQAIAKAIAKQAJATASAOQBBAxC1ACIDegHQBQgEAmgIQDBgUBKg0QA1gmAAhDQAAg6iIg3g");
	this.shape.setTransform(50.4,19.1);

	this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

}).prototype = getMCSymbolPrototype(lib.blueglowtummy, new cjs.Rectangle(-2,-2,104.9,42.3), null);


(lib.blueglownose = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer 1
	this.shape = new cjs.Shape();
	this.shape.graphics.f().s("#0099FF").ss(4,1,1).p("AB3AcQgQAtgpAXQgMAAgJAEQgIAEghAAQg+AAgjgzQgYgjAAgZQABgFAcgSQAhgUAOgcIATgYQBtgDAkBmQAGAPgGAQg");
	this.shape.setTransform(12.2,13.5);

	this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

}).prototype = getMCSymbolPrototype(lib.blueglownose, new cjs.Rectangle(-2,1.2,28.4,24.7), null);


(lib.blueglowlegs = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer 3
	this.shape = new cjs.Shape();
	this.shape.graphics.f().s("#0099FF").ss(4,1,1).p("AEjlIQgGAWgBAfQgHC+BVB/IhGAYQAZAhAfAsQAbAsAAA0QAAA2gRA0QgIAagJAZQgDgBgDABQgEABgDACQgBAAgBAAQAAABgBAAQgCACgBACQgJAJgSALQgRAJAAAIQAAAIAJADQABAAABAAIAAAAQAGgBAGgFQAAAAgBABQgBABgEAGQAIAAAEAAQA9AAALgJQABgCADgJQACgJAAgBQAAgEgGgGQALgEAPgKQAcgVAEgTQABgIALgXQAKgVABgIQADgWAaggQAOAlgGAdQgJAygHAdIAAAAQgFAPhCA7QgBABADAFQADAEAFAFQAAAAABABQAVAUAigOQAHgDALgDQAagCAHgGQACgDAEgKQAAgCABgCQAKgMANgSQAEgHAEgGQALgNACgMQADgPAAgWQABgVAAgMQAEgRABgFQAEgQADgMQAHgXAAgIIAEgRQABgNABgEQAHgUAAgVQAAggghgjQAAgEADgCQAIgFASghQAgg0AKgUQA9h1AAhmQAAhKgghAQgqhShTgaQg7gShSAqQg9AfghAmQgWAhgIAggAl5lfQgUgsgsgeQh0hNhFCIQgVArgOA6QgBADgBADQgDAPgCAMQgMARAFBCQABAVAJAgQATBHA/CLIhIAYQACABADAEQAWAUAAAQQAAAYAHAxQAAAPgJAQQgNAWgEAQQgDALgSA3QAAAAAAABQgBABgCACQgJAJgQAKQgQAJAAAHQAAAIAIADQABAAABAAIAAAAQAFgCAHgEQgBAAAAABQgBABgEAGQAHAAAFAAQAOAAAMgBQABAIAIACQABABACAAIAAgBQAGgBAIgGQgBABAAAAQgCACgEAHQAJAAAFAAQBGAAALgLQACgBABgEQA3goAOgaQAGgNAAgXQAAgZACgLQACgQAKgUQAKgUAOgQQAOgOADgVQAAgWACgMQAKhFAshRQAKgQAGgRQAWg0AAgvQAAgCAAgCQAAgagJgzQgJg3gLgaQgLgbgUgkg");
	this.shape.setTransform(-28.5,49.6);

	this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

}).prototype = getMCSymbolPrototype(lib.blueglowlegs, new cjs.Rectangle(-101.8,-1.6,146.6,102.5), null);


(lib.blueglowback = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer 1
	this.shape = new cjs.Shape();
	this.shape.graphics.f().s("#0099FF").ss(4,1,1).p("AG7hzQijg1jhgRQirgHhwAJQkWAfhBAkQgbAQgGAXQgBAEAAArQAAANASAfQAVAoAfAgQAKALAKAJQALATAWAOQBNAwDaACIELgHQBfgEAugHQDogUBZg0QBAglAAhCQAAg6ijg1g");
	this.shape.setTransform(60.6,18.9);

	this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

}).prototype = getMCSymbolPrototype(lib.blueglowback, new cjs.Rectangle(-2,-2,125.1,41.8), null);


(lib.PigTorso_excited_003 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer 2
	this.instance = new lib.PigTorso_excited_0030001();
	this.instance.parent = this;
	this.instance.setTransform(-60.5,-28.5,0.5,0.5);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(2));

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-60.5,-28.5,124,68);


(lib.PigTorso_excited_002 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Pig Torso_excited_0020001.png
	this.instance = new lib.PigTorso_excited_0020001();
	this.instance.parent = this;
	this.instance.setTransform(-60.5,-26.5,0.5,0.5);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(2));

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-60.5,-26.5,124,61);


(lib.PigTorso_excited_001 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Pig Torso0002.png
	this.instance = new lib.PigTorso0002();
	this.instance.parent = this;
	this.instance.setTransform(-60.3,-31,0.5,0.5);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

}).prototype = getMCSymbolPrototype(lib.PigTorso_excited_001, new cjs.Rectangle(-60.3,-31,125,66), null);


(lib.PigNeck = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer 2
	this.instance = new lib.PigNeck0001();
	this.instance.parent = this;
	this.instance.setTransform(-21.2,-27.4,0.5,0.5);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(2));

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-21.2,-27.4,47,59);


(lib.star_2_anim = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Star
	this.instance = new lib.SmallStar("synched",0);
	this.instance.parent = this;
	this.instance.setTransform(0.1,0.3,0.6,0.6);

	this.timeline.addTween(cjs.Tween.get(this.instance).to({guide:{path:[0.1,0.2,-4.2,-0.7,-6.2,-1.6,-9.1,-2.8,-9.1,-4.5,-9.1,-6.3,-6,-7.7,-4.2,-8.6,0.7,-10,5.6,-11.4,7.5,-12.3,10.6,-13.8,10.6,-15.6,10.6,-17.5,7.3,-18.9,5.3,-19.8,0.1,-21.1,-5.1,-22.4,-7,-23.2,-10.3,-24.5,-10.3,-26.3,-10.3,-28,-7.2,-29.3,-5.7,-30,-1.7,-31.1], orient:'auto'},alpha:0.102},16).wait(1));

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-5.1,-4.7,10.5,10);


(lib.star_1_anim = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Star
	this.instance = new lib.LargeStar("synched",0);
	this.instance.parent = this;
	this.instance.setTransform(0.1,0.3,0.6,0.6);

	this.timeline.addTween(cjs.Tween.get(this.instance).to({guide:{path:[0.1,0.2,4.5,-0.7,6.5,-1.6,9.4,-2.8,9.4,-4.5,9.4,-6.3,6.3,-7.7,4.5,-8.6,-0.4,-10,-5.3,-11.4,-7.2,-12.3,-10.3,-13.8,-10.3,-15.6,-10.3,-17.5,-7,-18.9,-5,-19.8,0.1,-21.1,5.4,-22.4,7.3,-23.2,10.6,-24.5,10.6,-26.3,10.6,-28,7.5,-29.3,6,-30,2,-31.1], orient:'auto'},alpha:0.102},13).wait(1));

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-6.9,-6.4,14,13.3);


(lib.sparkle2 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer 1
	this.innerSparkle = new lib.star_2_anim();
	this.innerSparkle.parent = this;

	this.timeline.addTween(cjs.Tween.get(this.innerSparkle).wait(1));

}).prototype = getMCSymbolPrototype(lib.sparkle2, new cjs.Rectangle(-5.2,-4.7,10.6,10), null);


(lib.sparkle1 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer 1
	this.innerSparkle = new lib.star_1_anim();
	this.innerSparkle.parent = this;

	this.timeline.addTween(cjs.Tween.get(this.innerSparkle).wait(1));

}).prototype = getMCSymbolPrototype(lib.sparkle1, new cjs.Rectangle(-6.9,-6.4,14,13.3), null);


(lib.Running_drop = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer 1
	this.instance = new lib.Wet_drop();
	this.instance.parent = this;
	this.instance.setTransform(4.8,10,1,1,0,0,0,4.8,10);
	this.instance.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,4);
	new cjs.ButtonHelper(this.instance, 0, 1, 1);

	this.timeline.addTween(cjs.Tween.get(this.instance).to({y:146.2},15).to({regX:4.5,scaleX:0.1,scaleY:0.1,y:182.5},4).to({_off:true},1).wait(5));

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-10,-10,37,48);


(lib.left_over_bubbles_sparse = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer 15
	this.instance = new lib.M_Wash_Bubble_1();
	this.instance.parent = this;
	this.instance.setTransform(59.6,9,0.075,0.075,-155.3,0,0,11.1,11.2);
	this.instance.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.instance_1 = new lib.M_Wash_Bubble_1();
	this.instance_1.parent = this;
	this.instance_1.setTransform(46.5,10.1,0.439,0.439,-153.7,0,0,11.2,11.1);
	this.instance_1.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.instance_2 = new lib.M_Wash_Bubble_1();
	this.instance_2.parent = this;
	this.instance_2.setTransform(55.1,9,0.162,0.162,-155.3,0,0,11.2,11.2);
	this.instance_2.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.instance_3 = new lib.M_Wash_Bubble_1();
	this.instance_3.parent = this;
	this.instance_3.setTransform(38.2,13,0.188,0.188,-155.4,0,0,11.1,10.7);
	this.instance_3.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.instance_4 = new lib.M_Wash_Bubble_1();
	this.instance_4.parent = this;
	this.instance_4.setTransform(40.7,8.6,0.28,0.28,-155.4,0,0,11.2,11.2);
	this.instance_4.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.instance_5 = new lib.M_Wash_Bubble_1();
	this.instance_5.parent = this;
	this.instance_5.setTransform(36.5,10.9,0.165,0.165,0,0,0,11,11);
	this.instance_5.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance_5},{t:this.instance_4},{t:this.instance_3},{t:this.instance_2},{t:this.instance_1},{t:this.instance}]}).wait(1));

}).prototype = getMCSymbolPrototype(lib.left_over_bubbles_sparse, new cjs.Rectangle(23.8,-13.3,50.1,48), null);


(lib.left_over_bubbles_few = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer 15
	this.instance = new lib.M_Wash_Bubble_1();
	this.instance.parent = this;
	this.instance.setTransform(42.3,6.2,0.075,0.075,-155.3,0,0,11,11.2);
	this.instance.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.instance_1 = new lib.M_Wash_Bubble_1();
	this.instance_1.parent = this;
	this.instance_1.setTransform(43.3,4.3,0.075,0.075,-155.3,0,0,11,11.2);
	this.instance_1.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.instance_2 = new lib.M_Wash_Bubble_1();
	this.instance_2.parent = this;
	this.instance_2.setTransform(39.9,6.5,0.075,0.075,-155.3,0,0,11.1,11.2);
	this.instance_2.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.instance_3 = new lib.M_Wash_Bubble_1();
	this.instance_3.parent = this;
	this.instance_3.setTransform(54,11,0.075,0.075,-155.3,0,0,11,11.2);
	this.instance_3.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.instance_4 = new lib.M_Wash_Bubble_1();
	this.instance_4.parent = this;
	this.instance_4.setTransform(46.5,10.1,0.439,0.439,-153.7,0,0,11.2,11.1);
	this.instance_4.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.instance_5 = new lib.M_Wash_Bubble_1();
	this.instance_5.parent = this;
	this.instance_5.setTransform(52.8,6.1,0.28,0.28,-155.4,0,0,11.2,11.2);
	this.instance_5.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance_5},{t:this.instance_4},{t:this.instance_3},{t:this.instance_2},{t:this.instance_1},{t:this.instance}]}).wait(1));

}).prototype = getMCSymbolPrototype(lib.left_over_bubbles_few, new cjs.Rectangle(23.8,-13.3,50.1,48), null);


(lib.left_over_bubbles_2 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer 15
	this.instance = new lib.M_Wash_Bubble_1();
	this.instance.parent = this;
	this.instance.setTransform(45.6,4.1,0.326,0.326,-155.4,0,0,11.3,11.2);
	this.instance.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.instance_1 = new lib.M_Wash_Bubble_1();
	this.instance_1.parent = this;
	this.instance_1.setTransform(52.8,6.1,0.28,0.28,-155.4,0,0,11.2,11.2);
	this.instance_1.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance_1},{t:this.instance}]}).wait(1));

}).prototype = getMCSymbolPrototype(lib.left_over_bubbles_2, new cjs.Rectangle(27.1,-14.9,46.8,40.7), null);


(lib.left_over_bubbles = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer 15
	this.instance = new lib.M_Wash_Bubble_1();
	this.instance.parent = this;
	this.instance.setTransform(70.8,4,0.404,0.404,4.9,0,0,11.1,10.3);
	this.instance.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.instance_1 = new lib.M_Wash_Bubble_1();
	this.instance_1.parent = this;
	this.instance_1.setTransform(64.4,1.4,0.289,0.289,4.9,0,0,11.1,10.3);
	this.instance_1.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.instance_2 = new lib.M_Wash_Bubble_1();
	this.instance_2.parent = this;
	this.instance_2.setTransform(31,4.8,0.289,0.289,4.9,0,0,11.1,10);
	this.instance_2.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.instance_3 = new lib.M_Wash_Bubble_1();
	this.instance_3.parent = this;
	this.instance_3.setTransform(29.7,12.7,0.431,0.431,4.9,0,0,11.3,11.2);
	this.instance_3.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.instance_4 = new lib.M_Wash_Bubble_1();
	this.instance_4.parent = this;
	this.instance_4.setTransform(34.6,7,0.253,0.253,160.3,0,0,10.8,10.8);
	this.instance_4.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.instance_5 = new lib.M_Wash_Bubble_1();
	this.instance_5.parent = this;
	this.instance_5.setTransform(55.1,9,0.162,0.162,-155.3,0,0,11.2,11.2);
	this.instance_5.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.instance_6 = new lib.M_Wash_Bubble_1();
	this.instance_6.parent = this;
	this.instance_6.setTransform(47.2,-5.1,0.267,0.267,-155.4,0,0,11.5,11.1);
	this.instance_6.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.instance_7 = new lib.M_Wash_Bubble_1();
	this.instance_7.parent = this;
	this.instance_7.setTransform(20.1,12.2,0.221,0.221,-155.4,0,0,11.3,11);
	this.instance_7.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.instance_8 = new lib.M_Wash_Bubble_1();
	this.instance_8.parent = this;
	this.instance_8.setTransform(20.2,17,0.162,0.162,-155.3,0,0,11.2,11.1);
	this.instance_8.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.instance_9 = new lib.M_Wash_Bubble_1();
	this.instance_9.parent = this;
	this.instance_9.setTransform(38.2,13,0.188,0.188,-155.4,0,0,11.1,10.7);
	this.instance_9.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.instance_10 = new lib.M_Wash_Bubble_1();
	this.instance_10.parent = this;
	this.instance_10.setTransform(40.7,8.6,0.28,0.28,-155.4,0,0,11.2,11.2);
	this.instance_10.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.instance_11 = new lib.M_Wash_Bubble_1();
	this.instance_11.parent = this;
	this.instance_11.setTransform(82.6,4.9,0.124,0.124,-155.3,0,0,10.5,11.2);
	this.instance_11.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.instance_12 = new lib.M_Wash_Bubble_1();
	this.instance_12.parent = this;
	this.instance_12.setTransform(36.5,10.9,0.165,0.165,0,0,0,11,11);
	this.instance_12.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance_12},{t:this.instance_11},{t:this.instance_10},{t:this.instance_9},{t:this.instance_8},{t:this.instance_7},{t:this.instance_6},{t:this.instance_5},{t:this.instance_4},{t:this.instance_3},{t:this.instance_2},{t:this.instance_1},{t:this.instance}]}).wait(1));

}).prototype = getMCSymbolPrototype(lib.left_over_bubbles, new cjs.Rectangle(5.3,-21.9,91.8,57.3), null);


(lib.Bubbles_together = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// M_Wash_Bubble
	this.instance = new lib.M_Wash_Bubble_1();
	this.instance.parent = this;
	this.instance.setTransform(30.1,18.9,0.303,0.303,-155.3,0,0,11,10.9);
	this.instance.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.instance_1 = new lib.M_Wash_Bubble_pop_1();
	this.instance_1.parent = this;
	this.instance_1.setTransform(30.2,18.9,0.757,0.757,-155.3,0,0,10.9,11);
	this.instance_1.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance}]}).to({state:[{t:this.instance}]},38).to({state:[{t:this.instance_1}]},2).to({state:[]},2).wait(50));
	this.timeline.addTween(cjs.Tween.get(this.instance).to({regX:10.9,regY:11,scaleX:0.76,scaleY:0.76,x:30.2},38).to({_off:true},2).wait(52));

	// M_Wash_Bubble
	this.instance_2 = new lib.M_Wash_Bubble_1();
	this.instance_2.parent = this;
	this.instance_2.setTransform(24.5,20.9,0.313,0.313,-155.3,0,0,11.1,11.1);
	this.instance_2.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.instance_3 = new lib.M_Wash_Bubble_pop_1();
	this.instance_3.parent = this;
	this.instance_3.setTransform(24.6,20.9,0.757,0.757,-155.3,0,0,11,11);
	this.instance_3.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance_2}]}).to({state:[{t:this.instance_2}]},40).to({state:[{t:this.instance_3}]},2).to({state:[]},2).wait(48));
	this.timeline.addTween(cjs.Tween.get(this.instance_2).to({regX:11,regY:11,scaleX:0.76,scaleY:0.76,x:24.6},40).to({_off:true},2).wait(50));

	// M_Wash_Bubble
	this.instance_4 = new lib.M_Wash_Bubble_1();
	this.instance_4.parent = this;
	this.instance_4.setTransform(39.6,16.1,0.287,0.287,-155.3,0,0,10.8,10.8);
	this.instance_4.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.instance_5 = new lib.M_Wash_Bubble_pop_1();
	this.instance_5.parent = this;
	this.instance_5.setTransform(39.6,16.1,0.757,0.757,-155.3,0,0,11,11);
	this.instance_5.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance_4}]}).to({state:[{t:this.instance_4}]},34).to({state:[{t:this.instance_5}]},2).to({state:[]},2).wait(54));
	this.timeline.addTween(cjs.Tween.get(this.instance_4).to({regX:11,regY:11,scaleX:0.76,scaleY:0.76},34).to({_off:true},2).wait(56));

	// M_Wash_Bubble
	this.instance_6 = new lib.M_Wash_Bubble_1();
	this.instance_6.parent = this;
	this.instance_6.setTransform(9.9,-2.5,0.199,0.199,-155.3,0,0,11,10.7);
	this.instance_6.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.instance_7 = new lib.M_Wash_Bubble_pop_1();
	this.instance_7.parent = this;
	this.instance_7.setTransform(9.8,-2.5,0.757,0.757,-155.3,0,0,11.1,11);
	this.instance_7.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance_6}]}).to({state:[{t:this.instance_7}]},32).to({state:[{t:this.instance_7}]},2).to({state:[]},2).wait(56));
	this.timeline.addTween(cjs.Tween.get(this.instance_6).to({_off:true,regX:11.1,regY:11,scaleX:0.76,scaleY:0.76,x:9.8},32).wait(60));

	// M_Wash_Bubble
	this.instance_8 = new lib.M_Wash_Bubble_1();
	this.instance_8.parent = this;
	this.instance_8.setTransform(25.7,-1.5,0.162,0.162,-155.3,0,0,11.2,11.2);
	this.instance_8.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.instance_9 = new lib.M_Wash_Bubble_pop_1();
	this.instance_9.parent = this;
	this.instance_9.setTransform(25.6,-1.5,0.757,0.757,-155.3,0,0,11.1,11);
	this.instance_9.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance_8}]}).to({state:[{t:this.instance_9}]},36).to({state:[{t:this.instance_9}]},2).to({state:[]},2).wait(52));
	this.timeline.addTween(cjs.Tween.get(this.instance_8).to({_off:true,regX:11.1,regY:11,scaleX:0.76,scaleY:0.76,x:25.6},36).wait(56));

	// M_Wash_Bubble
	this.instance_10 = new lib.M_Wash_Bubble_1();
	this.instance_10.parent = this;
	this.instance_10.setTransform(22.2,6,0.108,0.108,-155.3,0,0,11.1,11.8);
	this.instance_10.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.instance_11 = new lib.M_Wash_Bubble_pop_1();
	this.instance_11.parent = this;
	this.instance_11.setTransform(22,6,0.757,0.757,-155.3,0,0,11.2,10.9);
	this.instance_11.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance_10}]}).to({state:[{t:this.instance_11}]},30).to({state:[{t:this.instance_11}]},2).to({state:[]},2).wait(58));
	this.timeline.addTween(cjs.Tween.get(this.instance_10).to({_off:true,regX:11.2,regY:10.9,scaleX:0.76,scaleY:0.76,x:22},30).wait(62));

	// M_Wash_Bubble
	this.instance_12 = new lib.M_Wash_Bubble_1();
	this.instance_12.parent = this;
	this.instance_12.setTransform(29.2,-9,0.119,0.119,-155.3,0,0,11.5,11);
	this.instance_12.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.instance_13 = new lib.M_Wash_Bubble_pop_1();
	this.instance_13.parent = this;
	this.instance_13.setTransform(29.1,-9,0.757,0.757,-155.3,0,0,11.1,11);
	this.instance_13.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance_12}]}).to({state:[{t:this.instance_13}]},32).to({state:[{t:this.instance_13}]},2).to({state:[]},2).wait(56));
	this.timeline.addTween(cjs.Tween.get(this.instance_12).to({_off:true,regX:11.1,scaleX:0.76,scaleY:0.76,x:29.1},32).wait(60));

	// M_Wash_Bubble
	this.instance_14 = new lib.M_Wash_Bubble_1();
	this.instance_14.parent = this;
	this.instance_14.setTransform(42.2,-3.1,0.271,0.271,-155.3,0,0,10.3,11.3);
	this.instance_14.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.instance_15 = new lib.M_Wash_Bubble_pop_1();
	this.instance_15.parent = this;
	this.instance_15.setTransform(42.2,-3.1,0.757,0.757,-155.3,0,0,11,11.1);
	this.instance_15.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance_14}]}).to({state:[{t:this.instance_15}]},30).to({state:[{t:this.instance_15}]},2).to({state:[]},2).wait(58));
	this.timeline.addTween(cjs.Tween.get(this.instance_14).to({_off:true,regX:11,regY:11.1,scaleX:0.76,scaleY:0.76},30).wait(62));

	// M_Wash_Bubble
	this.instance_16 = new lib.M_Wash_Bubble_1();
	this.instance_16.parent = this;
	this.instance_16.setTransform(48.3,9,0.125,0.125,-155.3,0,0,11,10.5);
	this.instance_16.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.timeline.addTween(cjs.Tween.get(this.instance_16).to({regY:11,scaleX:0.76,scaleY:0.76,x:48.4,y:8.9},24).wait(2).to({_off:true},2).wait(64));

	// M_Wash_Bubble
	this.instance_17 = new lib.M_Wash_Bubble_1();
	this.instance_17.parent = this;
	this.instance_17.setTransform(32.6,-16.6,0.076,0.076,-155.3,0,0,10.8,11);
	this.instance_17.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.timeline.addTween(cjs.Tween.get(this.instance_17).to({regX:11,regY:11.1,scaleX:0.76,scaleY:0.76,y:-16.7},20).wait(2).to({_off:true},2).wait(68));

	// M_Wash_Bubble
	this.instance_18 = new lib.M_Wash_Bubble_1();
	this.instance_18.parent = this;
	this.instance_18.setTransform(35.5,5.1,0.103,0.103,-155.3,0,0,10.3,10.8);
	this.instance_18.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.timeline.addTween(cjs.Tween.get(this.instance_18).to({regX:11,regY:11.1,scaleX:0.76,scaleY:0.76,x:32.6,y:7.6},22).wait(2).to({regY:11,x:35.5,y:5.1},0).to({_off:true},2).wait(66));

	// M_Wash_Bubble
	this.instance_19 = new lib.M_Wash_Bubble_1();
	this.instance_19.parent = this;
	this.instance_19.setTransform(56,0.3,0.124,0.124,-155.3,0,0,10.5,11.2);
	this.instance_19.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.instance_20 = new lib.M_Wash_Bubble_pop_1();
	this.instance_20.parent = this;
	this.instance_20.setTransform(52,-4.5,0.686,0.686,-155.4,0,0,10.3,11.2);
	this.instance_20.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance_19}]}).to({state:[{t:this.instance_19}]},24).to({state:[{t:this.instance_20}]},2).to({state:[]},2).wait(64));
	this.timeline.addTween(cjs.Tween.get(this.instance_19).to({regX:10.3,scaleX:0.69,scaleY:0.69,rotation:-155.4,x:52,y:-4.5},24).to({_off:true},2).wait(66));

	// M_Wash_Bubble
	this.instance_21 = new lib.M_Wash_Bubble_1();
	this.instance_21.parent = this;
	this.instance_21.setTransform(52.4,20,0.067,0.067,-155.3,0,0,11.8,11.1);
	this.instance_21.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.instance_22 = new lib.M_Wash_Bubble_pop_1();
	this.instance_22.parent = this;
	this.instance_22.setTransform(52.4,19.8,0.757,0.757,-155.3,0,0,11.2,11.2);
	this.instance_22.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance_21}]}).to({state:[{t:this.instance_21}]},22).to({state:[{t:this.instance_22}]},8).to({state:[{t:this.instance_22}]},2).to({state:[]},2).wait(58));
	this.timeline.addTween(cjs.Tween.get(this.instance_21).to({regX:11.7,regY:11.2,scaleX:0.53,scaleY:0.53,rotation:-155.4,x:46.9,y:21.6},22).to({_off:true,regX:11.2,scaleX:0.76,scaleY:0.76,rotation:-155.3,x:52.4,y:19.8},8).wait(62));

	// M_Wash_Bubble
	this.instance_23 = new lib.M_Wash_Bubble_1();
	this.instance_23.parent = this;
	this.instance_23.setTransform(38.5,-8.5,0.4,0.4,0,0,0,11,11);
	this.instance_23.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.instance_24 = new lib.M_Wash_Bubble_pop_1();
	this.instance_24.parent = this;
	this.instance_24.setTransform(38.5,-8.5,1,1,0,0,0,11,11);
	this.instance_24.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance_23}]}).to({state:[{t:this.instance_23}]},38).to({state:[{t:this.instance_24}]},2).to({state:[]},2).wait(50));
	this.timeline.addTween(cjs.Tween.get(this.instance_23).to({scaleX:1,scaleY:1},38).to({_off:true},2).wait(52));

	// M_Wash_Bubble
	this.instance_25 = new lib.M_Wash_Bubble_1();
	this.instance_25.parent = this;
	this.instance_25.setTransform(44,-14,0.413,0.413,0,0,0,11,11);
	this.instance_25.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.instance_26 = new lib.M_Wash_Bubble_pop_1();
	this.instance_26.parent = this;
	this.instance_26.setTransform(44,-14,1,1,0,0,0,11,11);
	this.instance_26.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance_25}]}).to({state:[{t:this.instance_25}]},40).to({state:[{t:this.instance_26}]},2).to({state:[]},2).wait(48));
	this.timeline.addTween(cjs.Tween.get(this.instance_25).to({scaleX:1,scaleY:1},40).to({_off:true},2).wait(50));

	// M_Wash_Bubble
	this.instance_27 = new lib.M_Wash_Bubble_1();
	this.instance_27.parent = this;
	this.instance_27.setTransform(28.7,0,0.379,0.379,0,0,0,11,11);
	this.instance_27.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.instance_28 = new lib.M_Wash_Bubble_pop_1();
	this.instance_28.parent = this;
	this.instance_28.setTransform(28.7,0,1,1,0,0,0,11,11);
	this.instance_28.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance_27}]}).to({state:[{t:this.instance_27}]},34).to({state:[{t:this.instance_28}]},2).to({state:[]},2).wait(54));
	this.timeline.addTween(cjs.Tween.get(this.instance_27).to({scaleX:1,scaleY:1},34).to({_off:true},2).wait(56));

	// M_Wash_Bubble
	this.instance_29 = new lib.M_Wash_Bubble_1();
	this.instance_29.parent = this;
	this.instance_29.setTransform(74.5,6,0.263,0.263,0,0,0,11,11);
	this.instance_29.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.instance_30 = new lib.M_Wash_Bubble_pop_1();
	this.instance_30.parent = this;
	this.instance_30.setTransform(74.5,6,1,1,0,0,0,11,11);
	this.instance_30.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance_29}]}).to({state:[{t:this.instance_30}]},32).to({state:[{t:this.instance_30}]},2).to({state:[]},2).wait(56));
	this.timeline.addTween(cjs.Tween.get(this.instance_29).to({_off:true,scaleX:1,scaleY:1},32).wait(60));

	// M_Wash_Bubble
	this.instance_31 = new lib.M_Wash_Bubble_1();
	this.instance_31.parent = this;
	this.instance_31.setTransform(54.9,13.5,0.214,0.214,0,0,0,11,11.2);
	this.instance_31.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.instance_32 = new lib.M_Wash_Bubble_pop_1();
	this.instance_32.parent = this;
	this.instance_32.setTransform(54.9,13.5,1,1,0,0,0,11,11);
	this.instance_32.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance_31}]}).to({state:[{t:this.instance_32}]},36).to({state:[{t:this.instance_32}]},2).to({state:[]},2).wait(52));
	this.timeline.addTween(cjs.Tween.get(this.instance_31).to({_off:true,regY:11,scaleX:1,scaleY:1},36).wait(56));

	// M_Wash_Bubble
	this.instance_33 = new lib.M_Wash_Bubble_1();
	this.instance_33.parent = this;
	this.instance_33.setTransform(55,2.5,0.143,0.143,0,0,0,10.8,11.2);
	this.instance_33.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.instance_34 = new lib.M_Wash_Bubble_pop_1();
	this.instance_34.parent = this;
	this.instance_34.setTransform(55,2.5,1,1,0,0,0,11,11);
	this.instance_34.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance_33}]}).to({state:[{t:this.instance_34}]},30).to({state:[{t:this.instance_34}]},2).to({state:[]},2).wait(58));
	this.timeline.addTween(cjs.Tween.get(this.instance_33).to({_off:true,regX:11,regY:11,scaleX:1,scaleY:1},30).wait(62));

	// M_Wash_Bubble
	this.instance_35 = new lib.M_Wash_Bubble_1();
	this.instance_35.parent = this;
	this.instance_35.setTransform(54.9,24.5,0.157,0.157,0,0,0,11.2,11.2);
	this.instance_35.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.instance_36 = new lib.M_Wash_Bubble_pop_1();
	this.instance_36.parent = this;
	this.instance_36.setTransform(54.9,24.5,1,1,0,0,0,11,11);
	this.instance_36.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance_35}]}).to({state:[{t:this.instance_36}]},32).to({state:[{t:this.instance_36}]},2).to({state:[]},2).wait(56));
	this.timeline.addTween(cjs.Tween.get(this.instance_35).to({_off:true,regX:11,regY:11,scaleX:1,scaleY:1},32).wait(60));

	// M_Wash_Bubble
	this.instance_37 = new lib.M_Wash_Bubble_1();
	this.instance_37.parent = this;
	this.instance_37.setTransform(36,24.5,0.357,0.357,0,0,0,10.2,11.1);
	this.instance_37.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.instance_38 = new lib.M_Wash_Bubble_pop_1();
	this.instance_38.parent = this;
	this.instance_38.setTransform(36,24.5,1,1,0,0,0,11,11);
	this.instance_38.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance_37}]}).to({state:[{t:this.instance_38}]},30).to({state:[{t:this.instance_38}]},2).to({state:[]},2).wait(58));
	this.timeline.addTween(cjs.Tween.get(this.instance_37).to({_off:true,regX:11,regY:11,scaleX:1,scaleY:1},30).wait(62));

	// M_Wash_Bubble
	this.instance_39 = new lib.M_Wash_Bubble_1();
	this.instance_39.parent = this;
	this.instance_39.setTransform(22,13.5,0.165,0.165,0,0,0,10.9,11);
	this.instance_39.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.timeline.addTween(cjs.Tween.get(this.instance_39).to({regY:10.9,scaleX:0.91,scaleY:0.91,x:18.6,y:13.3},22).to({regX:11,regY:11,scaleX:1,scaleY:1,x:22,y:13.5},2).wait(2).to({_off:true},2).wait(64));

	// M_Wash_Bubble
	this.instance_40 = new lib.M_Wash_Bubble_1();
	this.instance_40.parent = this;
	this.instance_40.setTransform(39.7,11,0.136,0.136,0,0,0,11.1,11.1);
	this.instance_40.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.timeline.addTween(cjs.Tween.get(this.instance_40).to({regX:11,regY:11,scaleX:1,scaleY:1},22).wait(2).to({_off:true},2).wait(66));

	// M_Wash_Bubble
	this.instance_41 = new lib.M_Wash_Bubble_1();
	this.instance_41.parent = this;
	this.instance_41.setTransform(17.7,28,0.164,0.164,0,0,0,10.7,11);
	this.instance_41.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.timeline.addTween(cjs.Tween.get(this.instance_41).to({regX:11,scaleX:1,scaleY:1},24).wait(2).to({_off:true},2).wait(64));

	// M_Wash_Bubble
	this.instance_42 = new lib.M_Wash_Bubble_1();
	this.instance_42.parent = this;
	this.instance_42.setTransform(11,2.5,0.088,0.088,0,0,0,10.8,10.8);
	this.instance_42.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.instance_43 = new lib.M_Wash_Bubble_pop_1();
	this.instance_43.parent = this;
	this.instance_43.setTransform(11,2.5,1,1,0,0,0,11,11);
	this.instance_43.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance_42}]}).to({state:[{t:this.instance_43}]},30).to({state:[{t:this.instance_43}]},2).to({state:[]},2).wait(58));
	this.timeline.addTween(cjs.Tween.get(this.instance_42).to({_off:true,regX:11,regY:11,scaleX:1,scaleY:1},30).wait(62));

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-11.2,-37.9,114.4,94.8);


(lib.PigTorso_bubbles = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{wash:0,wash_stop:60});

	// Layer 2
	this.instance = new lib.Bubbles_together();
	this.instance.parent = this;
	this.instance.setTransform(21,-21.7,0.804,0.804,-158.2,0,0,35.9,11.2);

	this.instance_1 = new lib.Bubbles_together();
	this.instance_1.parent = this;
	this.instance_1.setTransform(-13.3,-17.8,0.713,0.713,0,0,0,36,11);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[]}).to({state:[{t:this.instance_1},{t:this.instance}]},1).to({state:[]},59).wait(44));

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = null;


(lib.PigHindLegBack = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{dirty:0,dirty_stop:1,"clean":2,clean_stop:3,glow:4,glow_stop:5,"wash":6,"wash_stop":602,"final":603,final_loop:604});

	// Pig Front Leg Back0001.png
	this.instance = new lib.PigHindLegBack0001();
	this.instance.parent = this;
	this.instance.setTransform(-15.2,-31.4,0.5,0.5);

	this.instance_1 = new lib.PigHindLegBack0002();
	this.instance_1.parent = this;
	this.instance_1.setTransform(-15.2,-31.4,0.5,0.5);

	this.instance_2 = new lib.pig_legGlow();
	this.instance_2.parent = this;
	this.instance_2.setTransform(33.2,-1.3,0.75,0.75,0,0,180,-28.4,49.6);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance}]}).to({state:[{t:this.instance_1}]},2).to({state:[{t:this.instance},{t:this.instance_2}]},2).to({state:[{t:this.instance_1}]},2).to({state:[]},599).wait(1));

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-15.2,-31.4,37,74);


(lib.PigHindLeg_bubbles = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{"wash":0,"wash_stop":60});

	// Layer 2
	this.instance = new lib.Bubbles_together();
	this.instance.parent = this;
	this.instance.setTransform(80,18.2,0.651,0.651,174,0,0,36,11.1);

	this.instance_1 = new lib.Bubbles_together();
	this.instance_1.parent = this;
	this.instance_1.setTransform(1.3,19.6,0.651,0.651,-80.9,0,0,36,11);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[]}).to({state:[{t:this.instance_1},{t:this.instance}]},1).to({state:[]},59).wait(44));

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = null;


(lib.PigHindLeg = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{"dirty":0,"dirty_stop":1,"clean":2,"clean_stop":3,"glow":4,"glow_stop":5,"wash":6,"wash_stop":602,"final":603,"final_loop":604});

	// Pig Hind Leg0001.png
	this.instance = new lib.PigHindLeg0001();
	this.instance.parent = this;
	this.instance.setTransform(-18.6,-38.9,0.5,0.5);

	this.instance_1 = new lib.left_over_bubbles_2();
	this.instance_1.parent = this;
	this.instance_1.setTransform(-3,30.1,0.5,0.5,-120,0,0,48.7,4.9);

	this.instance_2 = new lib.left_over_bubbles_few();
	this.instance_2.parent = this;
	this.instance_2.setTransform(-2.9,16.8,0.5,0.5,180,0,0,47.8,9.3);

	this.instance_3 = new lib.PigHindLeg0002();
	this.instance_3.parent = this;
	this.instance_3.setTransform(-18.6,-38.9,0.5,0.5);

	this.instance_4 = new lib.pig_legGlow();
	this.instance_4.parent = this;
	this.instance_4.setTransform(38.4,1.4,0.75,0.75,0,0,180,-28.4,49.6);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance}]}).to({state:[{t:this.instance_3},{t:this.instance_2},{t:this.instance_1}]},2).to({state:[{t:this.instance},{t:this.instance_4}]},2).to({state:[{t:this.instance_3}]},2).to({state:[{t:this.instance_3},{t:this.instance_2},{t:this.instance_1}]},6).to({state:[{t:this.instance_3}]},591).to({state:[]},2).wait(1));

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-18.6,-38.9,41,89);


(lib.PigHead_001_left_over = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{"wash":0,"wash_stop":60});

	// Layer 2
	this.instance = new lib.Bubbles_together("synched",0,false);
	this.instance.parent = this;
	this.instance.setTransform(7,12.3,0.452,0.452,145,0,0,35.9,10.8);
	this.instance._off = true;

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1).to({_off:false},0).to({_off:true},59).wait(44));

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = null;


(lib.PigHead_001 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{"dirty":0,"dirty_stop":1,"clean":2,clean_loop:3,"glow":4,glow_loop:5,"wash":6,"wash_stop":61,glowclean:62,glowclean_loop:63,"final":64,"final_loop":65});

	// Pig Head_0050001.png
	this.instance = new lib.PigHead_0010001();
	this.instance.parent = this;
	this.instance.setTransform(-23,-29.4,0.5,0.5);

	this.instance_1 = new lib.PigHead_0010002();
	this.instance_1.parent = this;
	this.instance_1.setTransform(-23,-29.4,0.5,0.5);

	this.instance_2 = new lib.pig_noseGlow();
	this.instance_2.parent = this;
	this.instance_2.setTransform(9.9,13,1,1,0,0,0,12.2,13.5);

	this.glow = new lib.blueglownose();
	this.glow.parent = this;
	this.glow.setTransform(9.9,13,1,1,0,0,0,12.2,13.5);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance}]}).to({state:[{t:this.instance_1}]},2).to({state:[{t:this.instance},{t:this.instance_2}]},2).to({state:[{t:this.instance_1}]},2).to({state:[{t:this.instance_1}]},55).to({state:[{t:this.instance_1},{t:this.glow}]},1).to({state:[{t:this.instance_1}]},2).to({state:[]},2).wait(160));

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-23,-29.4,54,63);


(lib.PigFrontLegBack = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{"dirty":0,"dirty_stop":1,"clean":2,"clean_stop":3,"glow":4,"glow_stop":5,"wash":6,"wash_stop":602,"final":603,"final_loop":604});

	// Pig Front Leg Back0001.png
	this.instance = new lib.PigFrontLegBack0001();
	this.instance.parent = this;
	this.instance.setTransform(-13.4,-27.8,0.5,0.5);

	this.instance_1 = new lib.PigFrontLegBack0002();
	this.instance_1.parent = this;
	this.instance_1.setTransform(-13.4,-27.8,0.5,0.5);

	this.instance_2 = new lib.pig_legGlow();
	this.instance_2.parent = this;
	this.instance_2.setTransform(-45.5,-5.5,0.75,0.75,0,0,180,-28.4,49.6);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance}]}).to({state:[{t:this.instance_1}]},2).to({state:[{t:this.instance},{t:this.instance_2}]},2).to({state:[{t:this.instance_1}]},2).to({state:[]},599).wait(1));

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-13.4,-27.8,34.3,71.3);


(lib.PigFrontLeg = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{"dirty":0,"dirty_stop":1,"clean":2,"clean_stop":3,"glow":4,"glow_stop":5,"wash":6,"wash_stop":61,"glowclean":64,"glowclean_loop":65,"final":66,"final_loop":67});

	// Pig Front Leg0002.png
	this.instance = new lib.PigFrontLeg0001();
	this.instance.parent = this;
	this.instance.setTransform(-15.9,-36.8,0.5,0.5);

	this.instance_1 = new lib.left_over_bubbles_2();
	this.instance_1.parent = this;
	this.instance_1.setTransform(6.5,32.2,0.5,0.5,0,0,0,48.9,4.8);

	this.instance_2 = new lib.PigFrontLeg0002();
	this.instance_2.parent = this;
	this.instance_2.setTransform(-15.9,-36.8,0.5,0.5);

	this.instance_3 = new lib.pig_legGlow();
	this.instance_3.parent = this;
	this.instance_3.setTransform(-37.4,1,0.75,0.75,0,0,180,-28.8,49.6);

	this.glow = new lib.blueglowlegs();
	this.glow.parent = this;
	this.glow.setTransform(-37.4,1,0.75,0.75,0,0,180,-28.8,49.6);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance}]}).to({state:[{t:this.instance_2},{t:this.instance_1}]},2).to({state:[{t:this.instance},{t:this.instance_3}]},2).to({state:[{t:this.instance_2}]},2).to({state:[{t:this.instance_2},{t:this.instance_1}]},25).to({state:[{t:this.instance_2},{t:this.instance_1}]},32).to({state:[{t:this.instance_2},{t:this.instance_1},{t:this.glow}]},1).to({state:[{t:this.instance_2}]},2).to({state:[]},2).wait(158));

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-26.2,-36.8,50.3,87.6);


(lib.pig_tummy_bubbles = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{"wash":0,"wash_stop":60});

	// Layer 4
	this.instance = new lib.Bubbles_together();
	this.instance.parent = this;
	this.instance.setTransform(-16.6,14.8,0.586,0.58,0,149.4,140.6,35.6,11);

	this.instance_1 = new lib.Bubbles_together();
	this.instance_1.parent = this;
	this.instance_1.setTransform(16.1,13.9,0.567,0.65,-54.2,0,0,35.4,11.4);

	this.instance_2 = new lib.Bubbles_together();
	this.instance_2.parent = this;
	this.instance_2.setTransform(5.4,19.4,0.612,0.605,0,-101.6,-110.4,35.2,10.9);

	this.instance_3 = new lib.Bubbles_together();
	this.instance_3.parent = this;
	this.instance_3.setTransform(26,18.8,0.642,0.635,0,162.2,153.4,35.7,10.8);

	this.instance_4 = new lib.Bubbles_together();
	this.instance_4.parent = this;
	this.instance_4.setTransform(-15.7,17.8,0.716,0.709,0,33.4,24.6,36.1,10.8);

	this.instance_5 = new lib.Bubbles_together();
	this.instance_5.parent = this;
	this.instance_5.setTransform(11.5,13.4,0.586,0.58,0,149.4,140.6,35.6,11.1);

	this.instance_6 = new lib.Bubbles_together();
	this.instance_6.parent = this;
	this.instance_6.setTransform(-19,22.9,0.567,0.65,-54.2,0,0,35.4,11.3);

	this.instance_7 = new lib.Bubbles_together();
	this.instance_7.parent = this;
	this.instance_7.setTransform(-13.6,18,0.646,0.646,35.6,0,0,35.5,10.4);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[]}).to({state:[{t:this.instance_7},{t:this.instance_6},{t:this.instance_5},{t:this.instance_4},{t:this.instance_3},{t:this.instance_2},{t:this.instance_1},{t:this.instance}]},1).to({state:[]},59).wait(44));

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = null;


(lib.water_drops_012 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer 1
	this.instance = new lib.Running_drop();
	this.instance.parent = this;
	this.instance.setTransform(175.7,46.7,0.486,0.486,0,0,180,4.8,10.1);
	this.instance._off = true;

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(7).to({_off:false},0).to({_off:true},24).wait(2));

	// WET DROPS
	this.instance_1 = new lib.Running_drop();
	this.instance_1.parent = this;
	this.instance_1.setTransform(70,37,0.486,0.486,0,0,180,4.8,10.1);
	this.instance_1._off = true;

	this.timeline.addTween(cjs.Tween.get(this.instance_1).wait(4).to({_off:false},0).to({_off:true},24).wait(5));

	// WET DROPS
	this.instance_2 = new lib.Running_drop();
	this.instance_2.parent = this;
	this.instance_2.setTransform(28.6,10.4,0.486,0.486,0,0,180,4.8,10.1);
	this.instance_2._off = true;

	this.timeline.addTween(cjs.Tween.get(this.instance_2).wait(1).to({_off:false},0).to({_off:true},24).wait(8));

	// WET DROPS
	this.instance_3 = new lib.Running_drop();
	this.instance_3.parent = this;
	this.instance_3.setTransform(-10.1,55.4,0.486,0.486,0,0,0,4.8,10.1);
	this.instance_3._off = true;

	this.timeline.addTween(cjs.Tween.get(this.instance_3).wait(6).to({_off:false},0).to({_off:true},24).wait(3));

	// WET DROPS
	this.instance_4 = new lib.Running_drop();
	this.instance_4.parent = this;
	this.instance_4.setTransform(91.1,10.7,0.486,0.486,0,0,0,4.8,10.1);
	this.instance_4._off = true;

	this.timeline.addTween(cjs.Tween.get(this.instance_4).wait(3).to({_off:false},0).to({_off:true},24).wait(6));

	// WET DROPS
	this.instance_5 = new lib.Running_drop();
	this.instance_5.parent = this;
	this.instance_5.setTransform(132.4,45.7,0.486,0.486,0,0,0,4.8,10.1);

	this.timeline.addTween(cjs.Tween.get(this.instance_5).to({_off:true},24).wait(9));

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(125.1,35.8,18,24);


(lib.pig_tummyMud_001 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{"dirty":0,dirty_loop:1,"clean":2,"clean_loop":3,"glow":4,"glow_loop":5,"wash":6,"wash_stop":100,"glowclean":101,"glowclean_loop":102,"final":103,"final_loop":104});

	// Layer 1
	this.shape = new cjs.Shape();
	this.shape.graphics.f("rgba(169,114,78,0.8)").s().p("AEqCNIACAAIgBADIgDABIACgEgAErCMIABgBIACgCIAEAAQhhgNhjABQhjAChggLQhVgMhQgEIAAAAIgBADIgBAAIgBAEIgPAAIgOgGIgJgBQgPgIgKgHIgDgDQgYgRgCgQQgMgOAAgiQgCgKACgLQAFgVAbAAIAYADIgCgCIgTgkQgCgGgBgVQAAgwApAIQAaAFBhAyQgEgTABgLQABgVAdAAQApAAA2AfQA4AiAWALQAEgnAlgCQAlgDA5AfQAzAdAnApQAKgEAKgDQBIgRABBNIgIAZQANACAMAGQASAJAAARQACAEAAADQgPADgNAHIgEAFIgDAAQgRAJgVACIgMgBIgEACIgDAAIgDAAgAmFgcQgEgGAAgIQAAgUAVAAQAVABgBAUIgBALQgFAKgOAAQgKAAgHgIgAD3hFQAAgiAaACQAbACAAAiIAAANQgFAOgUAAQgcAAAAgfgADOheQgFgGABgHQgBgUAVAAQAWAAgBAUQAAAHgCAEQgEAKgPAAQgLAAgFgIg");
	this.shape.setTransform(39.4,14.5);

	this.instance = new lib.left_over_bubbles_few();
	this.instance.parent = this;
	this.instance.setTransform(21.7,21.3,0.583,0.583,24.2,0,0,47.8,9.2);

	this.instance_1 = new lib.left_over_bubbles();
	this.instance_1.parent = this;
	this.instance_1.setTransform(48.7,17.5,0.548,0.548,-156.3,0,0,50.6,5.2);

	this.instance_2 = new lib.left_over_bubbles_sparse("synched",0,false);
	this.instance_2.parent = this;
	this.instance_2.setTransform(39.2,20.7,0.744,0.744,-159.8,0,0,35.5,10.8);

	this.instance_3 = new lib.pig_tummyGlow();
	this.instance_3.parent = this;
	this.instance_3.setTransform(43.6,8.7,1,1,0,0,180,50.4,19.2);

	this.glow = new lib.blueglowtummy();
	this.glow.parent = this;
	this.glow.setTransform(43.6,8.7,1,1,0,0,180,50.4,19.2);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.shape}]}).to({state:[{t:this.instance_2},{t:this.instance_1},{t:this.instance}]},2).to({state:[{t:this.shape},{t:this.instance_3}]},2).to({state:[]},2).to({state:[{t:this.instance_2},{t:this.instance_1},{t:this.instance}]},29).to({state:[{t:this.instance_2},{t:this.instance_1},{t:this.instance}]},65).to({state:[{t:this.instance_2},{t:this.instance_1},{t:this.instance},{t:this.glow}]},1).to({state:[]},2).to({state:[]},200).wait(1));

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(0,0,78.8,29.1);


(lib.pig_noseMud_001_left_over = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{"mud":0,"soap":45,"clean":57});

	// timeline functions:
	this.frame_0 = function() {
		/* 
		gameVars.noseMud.push(this);
		if (gameVars.noseMudClean == true) {this.alpha = 0;};*/
		/* stop();*/
	}
	this.frame_45 = function() {
		/* stop();*/
	}
	this.frame_57 = function() {
		/* stop();*/
	}

	// actions tween:
	this.timeline.addTween(cjs.Tween.get(this).call(this.frame_0).wait(45).call(this.frame_45).wait(12).call(this.frame_57).wait(12));

	// Layer 5
	this.instance = new lib.Bubbles_together("synched",0,false);
	this.instance.parent = this;
	this.instance.setTransform(10,7.9,0.452,0.452,145,0,0,35.9,10.8);
	this.instance._off = true;

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1).to({_off:false},0).to({_off:true},44).wait(24));

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = null;


(lib.pig_backMud_001_left_overs = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{"mud":0,"soap":45,"clean":57});

	// timeline functions:
	this.frame_0 = function() {
		/* stop();*/
	}
	this.frame_45 = function() {
		/* stop();*/
	}
	this.frame_57 = function() {
		/* stop();*/
	}

	// actions tween:
	this.timeline.addTween(cjs.Tween.get(this).call(this.frame_0).wait(45).call(this.frame_45).wait(12).call(this.frame_57).wait(12));

	// Layer 3
	this.instance = new lib.Bubbles_together();
	this.instance.parent = this;
	this.instance.setTransform(53.9,12.7,0.804,0.804,-158.2,0,0,35.9,11.2);

	this.instance_1 = new lib.Bubbles_together();
	this.instance_1.parent = this;
	this.instance_1.setTransform(19.5,16.6,0.713,0.713,0,0,0,35.9,11);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[]}).to({state:[{t:this.instance_1},{t:this.instance}]},1).to({state:[]},44).wait(24));

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = null;


(lib.pig_backMud_001 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{"dirty":0,"dirty_loop":1,"clean":2,"clean_loop":3,"glow":4,"glow_loop":5,"wash":6,"wash_stop":64,"glowclean":65,"glowclean_loop":66,"final":67,"final_loop":68});

	// Layer 1
	this.shape = new cjs.Shape();
	this.shape.graphics.f("rgba(169,114,78,0.8)").s().p("Ag5BpQgLgNgFgRIgRAFQgOADgTAAQgfAAgugfQgWgQgRgQIgXAHQgXAGgKAAQgZAAgigsIACgBQAJgFAKgDIAJgDIAEgGIAJgBIAHgFIAfgJQASgGAPgKIAcgFQBcgXBbgVQBdgWBhACQBVABBRALIAHgBQALAAAKACQgDAYgPAgQgcA6gvgRQgFALgGAdQgHAigFAOQgUA5g8AAQgSAAgegOIgbgOQgIAIgMAIQgXAQgpAAQgkAAgVgZg");
	this.shape.setTransform(36.5,16.2);

	this.instance = new lib.left_over_bubbles_few();
	this.instance.parent = this;
	this.instance.setTransform(52.5,16.8,0.531,0.531,178.6,0,0,47.8,9.3);

	this.instance_1 = new lib.left_over_bubbles_sparse();
	this.instance_1.parent = this;
	this.instance_1.setTransform(59.1,9.8,0.829,0.829,10.2,0,0,47.6,10.2);

	this.instance_2 = new lib.left_over_bubbles("synched",0,false);
	this.instance_2.parent = this;
	this.instance_2.setTransform(22.9,19.2,0.713,0.713,0,0,0,35.9,11.1);

	this.instance_3 = new lib.pig_backGlow();
	this.instance_3.parent = this;
	this.instance_3.setTransform(36.7,20,0.75,0.75,0,-7.6,172.4,60.5,18.9);

	this.glow = new lib.blueglowback();
	this.glow.parent = this;
	this.glow.setTransform(36.7,20,0.75,0.75,0,-7.6,172.4,60.5,18.9);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.shape}]}).to({state:[{t:this.instance_2},{t:this.instance_1},{t:this.instance}]},2).to({state:[{t:this.shape},{t:this.instance_3}]},2).to({state:[]},2).to({state:[{t:this.instance_2},{t:this.instance_1},{t:this.instance}]},26).to({state:[{t:this.instance_2},{t:this.instance_1},{t:this.instance}]},32).to({state:[{t:this.instance_2},{t:this.instance_1},{t:this.instance},{t:this.glow}]},1).to({state:[]},2).wait(260));

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(1,3.2,71,26.1);


(lib.PigTorso = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{"dirty":0,"clean":1,cleantummy:2,cleanback:3});

	// Layer 5
	this.tummymud = new lib.pig_tummyMud_001();
	this.tummymud.parent = this;
	this.tummymud.setTransform(-1.6,17.4,1,1,0,0,0,39.4,16.1);

	this.backmud = new lib.pig_backMud_001();
	this.backmud.parent = this;
	this.backmud.setTransform(2.5,-19,1,1,7,0,0,36.1,14.6);

	this.instance = new lib.PigTorso0002();
	this.instance.parent = this;
	this.instance.setTransform(-60.3,-31,0.5,0.5);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance},{t:this.backmud},{t:this.tummymud}]}).to({state:[{t:this.instance}]},1).to({state:[{t:this.instance},{t:this.backmud}]},1).to({state:[{t:this.instance},{t:this.tummymud}]},1).to({state:[]},1).wait(237));

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-60.3,-34.7,125,69.7);


(lib.PigHead_005 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{"dirty":0,"dirty_stop":1,"clean":2,"clean_loop":3,"glow":4,"glow_loop":5,"wash":6,"wash_stop":240,"glowclean":241,"glowclean_loop":242,"final":243,"final_loop":244});

	// bubbles
	this.instance = new lib.PigHead_001_left_over();
	this.instance.parent = this;
	this.instance.setTransform(38,1.4,1.082,1.082,0,0,180,-17.4,6.5);
	this.instance.shadow = new cjs.Shadow("rgba(0,0,0,1)",0,1,3);
	this.instance._off = true;

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(6).to({_off:false},0).to({_off:true},234).wait(6));

	// Pig Head_0050001.png
	this.instance_1 = new lib.PigHead_0050001();
	this.instance_1.parent = this;
	this.instance_1.setTransform(-23.7,-33.8,0.5,0.5);

	this.instance_2 = new lib.PigHead_0050002();
	this.instance_2.parent = this;
	this.instance_2.setTransform(-23.7,-33.8,0.5,0.5);

	this.instance_3 = new lib.pig_noseGlow();
	this.instance_3.parent = this;
	this.instance_3.setTransform(8,12.1,1,1,0,0,0,12.2,13.5);

	this.glow = new lib.blueglownose();
	this.glow.parent = this;
	this.glow.setTransform(9.9,13,0.795,1,0,0,0,12.2,13.5);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance_1}]}).to({state:[{t:this.instance_2}]},2).to({state:[{t:this.instance_1},{t:this.instance_3}]},2).to({state:[{t:this.instance_2}]},2).to({state:[{t:this.instance_2},{t:this.glow}]},235).to({state:[{t:this.instance_2}]},2).to({state:[]},2).wait(1));

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-28,-34.3,59.3,67.5);


(lib.PigHead_003 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{"dirty":0,"dirty_stop":1,"clean":2,"clean_loop":3,"glow":4,"glow_loop":5,"wash":6,"wash_stop":240,"glowclean":241,"glowclean_loop":242,"final":243,"final_loop":244});

	// bubbles
	this.instance = new lib.PigHead_001_left_over();
	this.instance.parent = this;
	this.instance.setTransform(38,1.4,1.082,1.082,0,0,180,-17.4,6.5);
	this.instance.shadow = new cjs.Shadow("rgba(0,0,0,1)",0,1,3);
	this.instance._off = true;

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(6).to({_off:false},0).to({_off:true},234).wait(6));

	// Pig Head_0050001.png
	this.instance_1 = new lib.PigHead_0030001();
	this.instance_1.parent = this;
	this.instance_1.setTransform(-23,-31.6,0.5,0.5);

	this.instance_2 = new lib.PigHead_0030002();
	this.instance_2.parent = this;
	this.instance_2.setTransform(-23,-31.6,0.5,0.5);

	this.instance_3 = new lib.pig_noseGlow();
	this.instance_3.parent = this;
	this.instance_3.setTransform(8.3,12.4,1,1,0,0,0,12.2,13.5);

	this.glow = new lib.blueglownose();
	this.glow.parent = this;
	this.glow.setTransform(9.9,13.1,0.713,0.758,0,0,0,12.2,13.6);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance_1}]}).to({state:[{t:this.instance_2}]},2).to({state:[{t:this.instance_1},{t:this.instance_3}]},2).to({state:[{t:this.instance_2}]},2).to({state:[{t:this.instance_2},{t:this.glow}]},235).to({state:[{t:this.instance_2}]},2).to({state:[]},2).wait(1));

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-23,-31.9,53,65.4);


(lib.Pig = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{wrongAnswer:0,wrongAnswer_stop:29,rest:30,rest_stop:299,wet:300,wet_stop:314,"clean":316,"clean_stop":408,excited:617,excited_stop:748,animalSound:808});

	// timeline functions:
	this.frame_28 = function() {
		/* gotoAndPlay("rest");*/
	}
	this.frame_298 = function() {
		/* stop();
		
		gameObjects._animal.restTimeout();*/
	}
	this.frame_314 = function() {
		/* stop();*/
	}
	this.frame_330 = function() {
		/* stop();*/
	}
	this.frame_473 = function() {
		/* 
		
		gameObjects._game.done();
		stop();*/
	}
	this.frame_523 = function() {
		/* gotoAndPlay("rest");*/
	}

	// actions tween:
	this.timeline.addTween(cjs.Tween.get(this).wait(28).call(this.frame_28).wait(270).call(this.frame_298).wait(16).call(this.frame_314).wait(16).call(this.frame_330).wait(143).call(this.frame_473).wait(50).call(this.frame_523).wait(317));

	// Pig Tummy
	this.tummy_bubbles = new lib.pig_tummy_bubbles();
	this.tummy_bubbles.parent = this;
	this.tummy_bubbles.setTransform(-2,-2.8,1.082,1.082,0,0,180);
	this.tummy_bubbles.shadow = new cjs.Shadow("#000000",0,1,3);

	this.timeline.addTween(cjs.Tween.get(this.tummy_bubbles).wait(30).to({_off:true},286).wait(524));

	// Pig Head
	this.nose_bubbles = new lib.PigHead_001_left_over();
	this.nose_bubbles.parent = this;
	this.nose_bubbles.setTransform(-62.6,21.9,1.082,1.082,0,0,180,-17.4,6.5);
	this.nose_bubbles.shadow = new cjs.Shadow("rgba(0,0,0,1)",0,1,3);

	this.timeline.addTween(cjs.Tween.get(this.nose_bubbles).wait(30).to({_off:true},286).wait(524));

	// Pig Torso
	this.back_bubbles = new lib.PigTorso_bubbles();
	this.back_bubbles.parent = this;
	this.back_bubbles.setTransform(-2,-2.8,1.082,1.082,0,0,180);
	this.back_bubbles.shadow = new cjs.Shadow("rgba(0,0,0,1)",0,1,3);

	this.timeline.addTween(cjs.Tween.get(this.back_bubbles).wait(30).to({_off:true},286).wait(524));

	// Pig Hind Leg
	this.legs_bubbles = new lib.PigHindLeg_bubbles();
	this.legs_bubbles.parent = this;
	this.legs_bubbles.setTransform(41.7,18.2,1.082,1.082,0,0,180);
	this.legs_bubbles.shadow = new cjs.Shadow("rgba(0,0,0,1)",0,1,3);

	this.timeline.addTween(cjs.Tween.get(this.legs_bubbles).wait(30).to({_off:true},286).wait(524));

	// drops
	this.instance = new lib.water_drops_012();
	this.instance.parent = this;
	this.instance.setTransform(-16.7,-2.7,0.6,0.6,0,0,180,92.4,49.1);
	this.instance._off = true;

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(300).to({_off:false},0).to({_off:true},16).wait(524));

	// sparkle
	this.instance_1 = new lib.sparkle();
	this.instance_1.parent = this;
	this.instance_1.setTransform(46.4,34.2,0.42,0.42);
	this.instance_1._off = true;

	this.timeline.addTween(cjs.Tween.get(this.instance_1).wait(455).to({_off:false},0).to({_off:true},20).wait(365));

	// sparkle
	this.instance_2 = new lib.sparkle();
	this.instance_2.parent = this;
	this.instance_2.setTransform(-56.5,-18.5,0.657,0.657);
	this.instance_2._off = true;

	this.timeline.addTween(cjs.Tween.get(this.instance_2).wait(445).to({_off:false},0).to({_off:true},30).wait(365));

	// sparkle
	this.instance_3 = new lib.sparkle();
	this.instance_3.parent = this;
	this.instance_3.setTransform(-31.4,22.3,0.352,0.352);
	this.instance_3._off = true;

	this.timeline.addTween(cjs.Tween.get(this.instance_3).wait(436).to({_off:false},0).to({_off:true},39).wait(365));

	// sparkle
	this.instance_4 = new lib.sparkle();
	this.instance_4.parent = this;
	this.instance_4.setTransform(31.5,-12.7,0.428,0.428);
	this.instance_4._off = true;

	this.timeline.addTween(cjs.Tween.get(this.instance_4).wait(424).to({_off:false},0).to({_off:true},51).wait(365));

	// Pig Head
	this.pig_head = new lib.PigHead_001();
	this.pig_head.parent = this;
	this.pig_head.setTransform(-62.6,21.9,1.082,1.082,0,0,180,-17.4,6.5);

	this.pig_head_1 = new lib.PigHead_003();
	this.pig_head_1.parent = this;
	this.pig_head_1.setTransform(-62.6,21.9,1.082,1.082,0,0,180,-17.4,6.5);
	this.pig_head_1._off = true;

	this.pig_head_2 = new lib.PigHead_005();
	this.pig_head_2.parent = this;
	this.pig_head_2.setTransform(-62.6,21.9,1.082,1.082,0,0,180,-17.4,6.5);
	this.pig_head_2._off = true;

	this.timeline.addTween(cjs.Tween.get(this.pig_head).to({_off:true},2).wait(24).to({_off:false},0).wait(4).to({_off:true},14).wait(32).to({_off:false},0).wait(36).to({regX:-17.1,regY:6.6,scaleX:1.08,scaleY:1.08,skewX:-4.3,skewY:175.7,x:-60.8,y:23},0).wait(2).to({regX:-17.4,regY:6.5,skewX:-8.5,skewY:171.5,x:-58.4,y:23.9},0).wait(2).to({regX:-17.3,skewX:-12.8,skewY:167.2,x:-56.4,y:24.9},0).wait(2).to({regX:-17.4,skewX:-17.1,skewY:162.9,x:-54.2,y:26},0).wait(2).to({regX:-17.3,scaleX:1.08,scaleY:1.08,skewX:-21.5,skewY:158.5,x:-52.2,y:27},0).wait(2).to({regX:-17.2,scaleX:1.08,scaleY:1.08,skewX:-21.3,skewY:158.7,x:-55.6},0).wait(2).to({regX:-16.4,regY:7.1,x:-59.5,y:27.9},0).wait(2).to({regX:-16.9,regY:6.6,x:-62.6,y:27.2},0).wait(2).to({regX:-17.2,regY:6.5,scaleX:1.08,scaleY:1.08,skewX:-21.5,skewY:158.5,x:-65.6,y:27.1},0).wait(2).to({scaleX:1.08,scaleY:1.08,skewX:-21.3,skewY:158.7},0).wait(2).to({scaleX:1.08,scaleY:1.08,skewX:-21.5,skewY:158.5},0).wait(2).to({regX:-17.4,scaleX:1.08,scaleY:1.08,skewX:-21.3,skewY:158.7,x:-64.7,y:23.4},0).wait(2).to({regX:-17.3,x:-64.3,y:20.1},0).wait(2).to({regX:-17.2,regY:6.4,x:-60.3,y:22.4},0).wait(2).to({regX:-17.3,regY:6.8,x:-56.1,y:25},0).wait(2).to({regY:6.5,scaleX:1.08,scaleY:1.08,skewX:-21.5,skewY:158.5,x:-52.2,y:27},0).wait(18).to({regX:-17.2,scaleX:1.08,scaleY:1.08,skewX:-14.3,skewY:165.7,x:-55.7,y:25.2},0).wait(2).to({skewX:-7,skewY:173,x:-59.3,y:23.5},0).wait(2).to({regX:-17.4,scaleX:1.08,scaleY:1.08,skewX:0,skewY:180,x:-62.6,y:21.9},0).wait(2).to({regY:6.8,y:22.2},0).wait(8).to({regY:6.5,y:21.9},0).wait(2).to({regX:-17.2,regY:6.4,scaleX:1.08,scaleY:1.08,skewX:-7,skewY:173,x:-59.2,y:23.4},0).wait(2).to({regX:-16.9,regY:6.5,skewX:-14.3,skewY:165.7,x:-56.1,y:25.5},0).wait(2).to({regX:-17.3,scaleX:1.08,scaleY:1.08,skewX:-21.5,skewY:158.5,x:-52.2,y:27},0).wait(2).to({regX:-16.4,regY:7.1,scaleX:1.08,scaleY:1.08,skewX:-21.3,skewY:158.7,x:-59.5,y:27.9},0).wait(2).to({regX:-17.2,regY:6.5,scaleX:1.08,scaleY:1.08,skewX:-21.5,skewY:158.5,x:-65.6,y:27.1},0).wait(2).to({scaleX:1.08,scaleY:1.08,skewX:-21.3,skewY:158.7},0).wait(2).to({scaleX:1.08,scaleY:1.08,skewX:-21.5,skewY:158.5},0).wait(2).to({regX:-17.3,scaleX:1.08,scaleY:1.08,skewX:-21.3,skewY:158.7,x:-64.3,y:20.1},0).wait(2).to({regY:6.4,x:-58.2,y:23.4},0).wait(2).to({regY:6.5,scaleX:1.08,scaleY:1.08,skewX:-21.5,skewY:158.5,x:-52.2,y:27},0).wait(14).to({regX:-16.4,regY:7.1,scaleX:1.08,scaleY:1.08,skewX:-21.3,skewY:158.7,x:-59.5,y:27.9},0).wait(2).to({regX:-17.2,regY:6.5,scaleX:1.08,scaleY:1.08,skewX:-21.5,skewY:158.5,x:-65.6,y:27.1},0).wait(2).to({scaleX:1.08,scaleY:1.08,skewX:-21.3,skewY:158.7},0).wait(2).to({scaleX:1.08,scaleY:1.08,skewX:-21.5,skewY:158.5},0).wait(2).to({regX:-17.3,scaleX:1.08,scaleY:1.08,skewX:-21.3,skewY:158.7,x:-64.3,y:20.1},0).wait(2).to({regY:6.4,x:-58.2,y:23.4},0).wait(2).to({regY:6.5,scaleX:1.08,scaleY:1.08,skewX:-21.5,skewY:158.5,x:-52.2,y:27},0).wait(2).to({regX:-17.2,scaleX:1.08,scaleY:1.08,skewX:-14.3,skewY:165.7,x:-55.7,y:25.2},0).wait(2).to({skewX:-7,skewY:173,x:-59.3,y:23.5},0).to({_off:true},2).wait(32).to({_off:false,regX:-17.4,scaleX:1.08,scaleY:1.08,skewX:0,skewY:180,x:-62.6,y:21.9},0).wait(20).to({regX:-17.3,skewX:-21.5,skewY:158.5,x:-52.2,y:27},0).wait(2).to({regX:-17.2,scaleX:1.08,scaleY:1.08,skewX:-22,skewY:158,x:-52.1,y:27.8},0).wait(2).to({regY:6.8,skewX:-22.6,skewY:157.4,x:-51.9,y:29},0).wait(2).to({regY:6.3,scaleX:1.08,scaleY:1.08,skewX:-23.2,skewY:156.8,x:-51.7,y:29.6},0).wait(2).to({scaleX:1.08,scaleY:1.08,skewX:-15.3,skewY:164.7,x:-55.4,y:27},0).wait(2).to({regY:6.2,skewX:-7.6,skewY:172.4,x:-59,y:24.4},0).wait(2).to({regX:-17.4,regY:6.5,scaleX:1.08,scaleY:1.08,skewX:0,skewY:180,x:-62.6,y:21.9},0).wait(337).to({scaleX:1.08,scaleY:1.08,skewX:8.8,skewY:188.8,x:-65.7,y:28.7},0).wait(2).to({regX:-17,regY:5.8,scaleX:1.08,scaleY:1.08,skewX:11.8,skewY:191.8,x:-66.8,y:31},0).wait(2).to({regX:-16.9,scaleX:1.08,scaleY:1.08,skewX:5.8,skewY:185.8,x:-64.8,y:26.4},0).wait(2).to({regX:-17.4,regY:6.5,scaleX:1.08,scaleY:1.08,skewX:0,skewY:180,x:-62.6,y:21.9},0).wait(2).to({regX:-17.8,regY:6.9,scaleX:1.08,scaleY:1.08,skewX:20.3,skewY:200.3,x:-63.2,y:11.7},0).wait(2).to({regX:-17.4,regY:6.5,scaleX:1.08,scaleY:1.08,skewX:40.9,skewY:220.9,x:-64.2,y:0.3},0).wait(2).to({regX:-17.6,scaleX:1.08,scaleY:1.08,skewX:61.3,skewY:241.3,x:-65.1,y:-10.5},0).wait(2).to({scaleX:1.1,scaleY:1.1,skewX:61.4,skewY:241.4,x:-64.4,y:-9.7},0).wait(2).to({regX:-18.2,regY:6.7,scaleX:1.11,scaleY:1.11,x:-63.4,y:-8.2},0).to({_off:true},2).wait(6).to({_off:false,regX:-17.6,regY:6.5,scaleX:1.08,scaleY:1.08,skewX:61.3,skewY:241.3,x:-65.1,y:-10.5},0).wait(2).to({scaleX:1.1,scaleY:1.1,skewX:61.4,skewY:241.4,x:-64.4,y:-9.7},0).wait(2).to({regX:-18.2,regY:6.7,scaleX:1.11,scaleY:1.11,x:-63.4,y:-8.2},0).to({_off:true},2).wait(6).to({_off:false,regX:-17.6,regY:6.5,scaleX:1.08,scaleY:1.08,skewX:61.3,skewY:241.3,x:-65.1,y:-10.5},0).wait(24).to({regX:-17.5,regY:6.2,scaleX:1.08,scaleY:1.08,skewX:50.2,skewY:230.2,x:-64.5,y:-5.9},0).wait(2).to({regX:-17.7,regY:6.6,scaleX:1.08,scaleY:1.08,skewX:39.2,skewY:219.2,x:-64.3,y:-0.7},0).wait(2).to({regY:6.5,skewX:19.6,skewY:199.6,x:-63.4,y:10.6},0).wait(2).to({regX:-17.4,scaleX:1.08,scaleY:1.08,skewX:0,skewY:180,x:-62.6,y:21.9},0).wait(2).to({regX:-17.2,regY:6.3,scaleX:1.08,scaleY:1.08,skewX:5.8,skewY:185.8,x:-66.7,y:27.4},0).wait(2).to({skewX:2.8,skewY:182.8,x:-64.7,y:24.6},0).wait(2).to({regX:-17.4,regY:6.5,scaleX:1.08,scaleY:1.08,skewX:0,skewY:180,x:-62.6,y:21.9},0).wait(66).to({scaleX:1.08,scaleY:1.08,skewX:8.8,skewY:188.8,x:-65.7,y:28.7},0).wait(2).to({regX:-17,regY:5.8,scaleX:1.08,scaleY:1.08,skewX:11.8,skewY:191.8,x:-66.8,y:31},0).wait(2).to({regX:-16.9,scaleX:1.08,scaleY:1.08,skewX:5.8,skewY:185.8,x:-64.8,y:26.4},0).wait(2).to({regX:-17.4,regY:6.5,scaleX:1.08,scaleY:1.08,skewX:0,skewY:180,x:-62.6,y:21.9},0).wait(2).to({regX:-17.8,regY:6.9,scaleX:1.08,scaleY:1.08,skewX:20.3,skewY:200.3,x:-63.2,y:11.7},0).wait(2).to({regX:-17.4,regY:6.5,scaleX:1.08,scaleY:1.08,skewX:40.9,skewY:220.9,x:-64.2,y:0.3},0).wait(2).to({regX:-17.6,scaleX:1.08,scaleY:1.08,skewX:61.3,skewY:241.3,x:-65.1,y:-10.5},0).wait(2).to({scaleX:1.1,scaleY:1.1,skewX:61.4,skewY:241.4,x:-64.4,y:-9.7},0).wait(2).to({regX:-18.2,regY:6.7,scaleX:1.11,scaleY:1.11,x:-63.4,y:-8.2},0).to({_off:true},2).wait(6).to({_off:false,regX:-17.6,regY:6.5,scaleX:1.08,scaleY:1.08,skewX:61.3,skewY:241.3,x:-65.1,y:-10.5},0).wait(4).to({regX:-17.5,regY:6.2,scaleX:1.08,scaleY:1.08,skewX:50.2,skewY:230.2,x:-64.5,y:-5.9},0).wait(2).to({regX:-17.7,regY:6.6,scaleX:1.08,scaleY:1.08,skewX:39.2,skewY:219.2,x:-64.3,y:-0.7},0).wait(2).to({regY:6.5,skewX:19.6,skewY:199.6,x:-63.4,y:10.6},0).wait(2).to({regX:-17.4,scaleX:1.08,scaleY:1.08,skewX:0,skewY:180,x:-62.6,y:21.9},0).wait(2).to({regX:-17.2,regY:6.3,scaleX:1.08,scaleY:1.08,skewX:5.8,skewY:185.8,x:-66.7,y:27.4},0).wait(2).to({skewX:2.8,skewY:182.8,x:-64.7,y:24.6},0).wait(2).to({regX:-17.4,regY:6.5,scaleX:1.08,scaleY:1.08,skewX:0,skewY:180,x:-62.6,y:21.9},0).to({_off:true},4).wait(31));
	this.timeline.addTween(cjs.Tween.get(this.pig_head_1).wait(2).to({_off:false},0).to({_off:true},2).wait(20).to({_off:false},0).to({_off:true},2).wait(18).to({_off:false},0).to({_off:true},2).wait(28).to({_off:false},0).to({_off:true},2).wait(150).to({_off:false},0).to({_off:true},2).wait(28).to({_off:false},0).to({_off:true},2).wait(387).to({_off:false,scaleX:1.13,scaleY:1.13,skewX:61.3,skewY:241.3,x:-62.9,y:-8.1},0).wait(2).to({regX:-17.3,regY:6.6,scaleX:1.11,scaleY:1.11,skewX:61.4,skewY:241.4,x:-63.9,y:-8.9},0).wait(2).to({regX:-17.4,regY:6.5,scaleX:1.1,scaleY:1.1,x:-64.4,y:-9.7},0).to({_off:true},2).wait(6).to({_off:false,scaleX:1.13,scaleY:1.13,skewX:61.3,skewY:241.3,x:-62.9,y:-8.1},0).wait(2).to({regX:-17.3,regY:6.6,scaleX:1.11,scaleY:1.11,skewX:61.4,skewY:241.4,x:-63.9,y:-8.9},0).wait(2).to({regX:-17.4,regY:6.5,scaleX:1.1,scaleY:1.1,x:-64.4,y:-9.7},0).to({_off:true},2).wait(120).to({_off:false,scaleX:1.13,scaleY:1.13,skewX:61.3,skewY:241.3,x:-62.9,y:-8.1},0).wait(2).to({regX:-17.3,regY:6.6,scaleX:1.11,scaleY:1.11,skewX:61.4,skewY:241.4,x:-63.9,y:-8.9},0).wait(2).to({regX:-17.4,regY:6.5,scaleX:1.1,scaleY:1.1,x:-64.4,y:-9.7},0).to({_off:true},2).wait(51));
	this.timeline.addTween(cjs.Tween.get(this.pig_head_2).wait(4).to({_off:false},0).wait(18).to({_off:true},2).wait(22).to({_off:false},0).wait(26).to({_off:true},2).wait(154).to({_off:false},0).wait(26).to({_off:true},2).wait(584));

	// Pig Front Leg
	this.pig_frontleg = new lib.PigFrontLeg();
	this.pig_frontleg.parent = this;
	this.pig_frontleg.setTransform(-41.6,18.9,1.082,1.082,0,0,180);

	this.timeline.addTween(cjs.Tween.get(this.pig_frontleg).wait(112).to({scaleY:1.05,skewX:0.5,x:-41.2,y:19.9},0).wait(2).to({scaleY:1.02,skewX:1,x:-40.9,y:21},0).wait(2).to({scaleY:0.99,skewX:1.5,x:-40.6,y:22.1},0).wait(2).to({scaleY:0.96,skewX:2,x:-40.2,y:23.2},0).wait(2).to({scaleY:0.92,skewX:2.7,x:-39.9,y:24.2},0).wait(2).to({scaleY:0.95,skewX:3,x:-39.6,y:23.4},0).wait(2).to({scaleY:0.98,skewX:3.3,x:-39.4,y:22.7},0).wait(2).to({scaleY:1,skewX:3.8,x:-39.1,y:21.8},0).wait(2).to({scaleY:1.03,skewX:4.3,x:-38.9,y:21},0).wait(6).to({scaleY:1.03,skewX:5.1,x:-38.2},0).wait(2).to({scaleY:1.03,skewX:6.1,x:-37.6},0).wait(2).to({scaleY:1.03,skewX:7.1,x:-37},0).wait(2).to({scaleY:1.03,skewX:8,x:-36.4},0).wait(2).to({scaleY:1.04,skewX:9.2,x:-35.7},0).wait(18).to({scaleY:1.05,skewX:6,x:-37.6,y:20.3},0).wait(2).to({scaleY:1.07,skewX:3,x:-39.6,y:19.6},0).wait(2).to({scaleY:1.08,skewX:0,x:-41.6,y:18.9},0).wait(12).to({scaleY:1.03,skewX:0.8,x:-41,y:20.7},0).wait(2).to({scaleY:0.98,skewX:1.8,x:-40.4,y:22.4},0).wait(2).to({scaleY:0.92,skewX:2.7,x:-39.9,y:24.2},0).wait(2).to({scaleY:0.98,skewX:3.3,x:-39.4,y:22.7},0).wait(2).to({scaleY:1.03,skewX:4.3,x:-38.9,y:21},0).wait(6).to({scaleY:0.99,skewX:3.6,x:-39.2,y:22.1},0).wait(2).to({scaleY:0.96,skewX:3.1,x:-39.5,y:23.1},0).wait(2).to({scaleY:0.92,skewX:2.7,x:-39.9,y:24.2},0).wait(14).to({scaleY:0.98,skewX:3.3,x:-39.4,y:22.7},0).wait(2).to({scaleY:1.03,skewX:4.3,x:-38.9,y:21},0).wait(6).to({scaleY:1.03,skewX:5.8,x:-37.8},0).wait(2).to({scaleY:1.03,skewX:7.5,x:-36.8},0).wait(2).to({scaleY:1.04,skewX:9.2,x:-35.7},0).wait(60).to({scaleY:1,skewX:8,x:-36.5,y:22.2},0).wait(2).to({scaleY:0.97,skewX:7,x:-37.3,y:23.3},0).wait(2).to({scaleY:0.93,skewX:6,x:-38.1,y:24.5},0).wait(2).to({scaleY:0.98,skewX:3.8,x:-39.3,y:22.6},0).wait(2).to({scaleY:1.03,skewX:1.8,x:-40.4,y:20.8},0).wait(2).to({scaleY:1.08,skewX:0,x:-41.6,y:18.9},0).wait(337).to({scaleY:1,y:21.7},0).wait(2).to({scaleY:0.98,y:22.6},0).wait(2).to({scaleY:1.03,y:20.8},0).wait(2).to({scaleY:1.08,y:18.9},0).wait(2).to({scaleY:1.07,skewX:2.8,x:-39.7,y:19.3},0).wait(2).to({scaleY:1.07,skewX:5.8,x:-37.7,y:19.7},0).wait(2).to({scaleY:1.06,skewX:8.8,x:-35.8,y:20.1},0).wait(2).to({scaleX:1.1,scaleY:1.06,x:-35.4},0).wait(2).to({scaleX:1.11,scaleY:1.06,skewX:9,x:-35.1},0).wait(2).to({scaleX:1.13,scaleY:1.06,skewX:9.1,x:-34.8},0).wait(2).to({scaleX:1.11,scaleY:1.06,skewX:9,x:-35.1},0).wait(2).to({scaleX:1.1,scaleY:1.06,skewX:8.8,x:-35.5},0).wait(2).to({scaleX:1.08,scaleY:1.06,x:-35.8},0).wait(2).to({scaleX:1.1,scaleY:1.06,x:-35.3},0).wait(2).to({scaleX:1.12,scaleY:1.06,skewX:9,x:-34.9},0).wait(2).to({scaleX:1.14,scaleY:1.06,skewX:9.2,x:-34.5},0).wait(2).to({scaleX:1.12,scaleY:1.06,skewX:9,x:-34.9},0).wait(2).to({scaleX:1.1,scaleY:1.06,skewX:8.8,x:-35.4},0).wait(2).to({scaleX:1.08,scaleY:1.06,x:-35.8},0).wait(24).to({scaleY:1.11,skewX:8.6,x:-35.6,y:18.6},0).wait(2).to({scaleY:1.15,x:-35.4,y:17},0).wait(2).to({scaleY:1.12,skewX:4.3,x:-38.5,y:17.9},0).wait(2).to({scaleY:1.08,skewX:0,x:-41.6,y:18.9},0).wait(2).to({scaleY:1.03,skewX:-1.3,x:-42.4,y:20.8},0).wait(2).to({scaleY:1.06,skewX:-0.5,x:-42,y:19.8},0).wait(2).to({scaleY:1.08,skewX:0,x:-41.6,y:18.9},0).wait(66).to({scaleY:1,y:21.7},0).wait(2).to({scaleY:0.98,y:22.6},0).wait(2).to({scaleY:1.03,y:20.8},0).wait(2).to({scaleY:1.08,y:18.9},0).wait(2).to({scaleY:1.07,skewX:2.8,x:-39.7,y:19.3},0).wait(2).to({scaleY:1.07,skewX:5.8,x:-37.7,y:19.7},0).wait(2).to({scaleY:1.06,skewX:8.8,x:-35.8,y:20.1},0).wait(2).to({scaleX:1.1,scaleY:1.06,x:-35.4},0).wait(2).to({scaleX:1.11,scaleY:1.06,skewX:9,x:-35.1},0).wait(2).to({scaleX:1.13,scaleY:1.06,skewX:9.1,x:-34.8},0).wait(2).to({scaleX:1.11,scaleY:1.06,skewX:9,x:-35.1},0).wait(2).to({scaleX:1.1,scaleY:1.06,skewX:8.8,x:-35.5},0).wait(2).to({scaleX:1.08,scaleY:1.06,x:-35.8},0).wait(4).to({scaleY:1.11,skewX:8.6,x:-35.6,y:18.6},0).wait(2).to({scaleY:1.15,x:-35.4,y:17},0).wait(2).to({scaleY:1.12,skewX:4.3,x:-38.5,y:17.9},0).wait(2).to({scaleY:1.08,skewX:0,x:-41.6,y:18.9},0).wait(2).to({scaleY:1.03,skewX:-1.3,x:-42.4,y:20.8},0).wait(2).to({scaleY:1.06,skewX:-0.5,x:-42,y:19.8},0).wait(2).to({scaleY:1.08,skewX:0,x:-41.6,y:18.9},0).to({_off:true},4).wait(31));

	// Pig Neck
	this.instance_5 = new lib.PigNeck();
	this.instance_5.parent = this;
	this.instance_5.setTransform(-52.3,2.6,1.082,1.082,0,0,180,-7.1,-1.9);

	this.timeline.addTween(cjs.Tween.get(this.instance_5).wait(112).to({regX:-6.7,scaleX:1.08,scaleY:1.08,skewX:-4.3,skewY:175.7,x:-52.1,y:3.1},0).wait(2).to({regX:-7.2,regY:-1.1,skewX:-8.5,skewY:171.5,x:-51,y:4.5},0).wait(2).to({regY:-2.3,skewX:-12.8,skewY:167.2,x:-50.7,y:3.8},0).wait(2).to({regX:-7.1,regY:-2,skewX:-17.1,skewY:162.9,x:-50.2,y:4.6},0).wait(2).to({regY:-1.9,scaleX:1.08,scaleY:1.08,skewX:-21.5,skewY:158.5,x:-49.6,y:5.3},0).wait(2).to({regX:-6.9,scaleX:1.15,scaleY:1.08,skewX:-17.8,skewY:159,x:-50.1},0).wait(2).to({regX:-7.4,regY:-1.7,scaleX:1.23,scaleY:1.09,skewX:-14.3,skewY:159.5,x:-49.8,y:5.4},0).wait(2).to({regX:-7,regY:-1.9,scaleX:1.3,scaleY:1.09,skewX:-10.8,skewY:160,x:-50.6,y:5.3},0).wait(2).to({regX:-7.2,regY:-1.8,scaleX:1.38,scaleY:1.1,skewX:-7.2,skewY:160.4,x:-50.9},0).wait(2).to({regY:-1.9,scaleX:1.38,scaleY:1.1,skewX:-7.1,skewY:160.5,x:-50.8,y:5.2},0).wait(2).to({regY:-1.8,scaleX:1.38,scaleY:1.1,skewX:-7.2,skewY:160.4,x:-50.9,y:5.3},0).wait(2).to({regX:-7,regY:-1.7,scaleX:1.32,scaleY:1.05,skewX:-10,skewY:168.5,y:5.5},0).wait(2).to({regX:-7.2,regY:-1.8,scaleX:1.26,scaleY:1.01,skewX:-12.8,skewY:176.3,x:-50.5,y:5.2},0).wait(2).to({regY:-3,scaleX:1.2,scaleY:1.03,skewX:-15.6,skewY:170.5,x:-50.6,y:4},0).wait(2).to({regX:-7.3,regY:-1.7,scaleX:1.14,scaleY:1.06,skewX:-18.5,skewY:164.5,x:-49.8,y:5.3},0).wait(2).to({regX:-7.1,regY:-1.9,scaleX:1.08,scaleY:1.08,skewX:-21.5,skewY:158.5,x:-49.6},0).wait(18).to({regX:-7,scaleX:1.08,scaleY:1.08,skewX:-14.3,skewY:165.7,x:-50.6,y:4.4},0).wait(2).to({regX:-6.5,regY:-2.2,skewX:-7,skewY:173,x:-52,y:3.2},0).wait(2).to({regX:-7.1,regY:-1.9,scaleX:1.08,scaleY:1.08,skewX:0,skewY:180,x:-52.3,y:2.6},0).wait(12).to({regX:-7.2,regY:-2,scaleX:1.08,scaleY:1.08,skewX:-7,skewY:173,x:-51.3,y:3.3},0).wait(2).to({regX:-7.1,regY:-1.9,skewX:-14.3,skewY:165.7,x:-50.5,y:4.4},0).wait(2).to({scaleX:1.08,scaleY:1.08,skewX:-21.5,skewY:158.5,x:-49.6,y:5.3},0).wait(2).to({regX:-7.4,regY:-1.7,scaleX:1.23,scaleY:1.09,skewX:-14.3,skewY:159.5,x:-49.8,y:5.4},0).wait(2).to({regX:-7.2,regY:-1.8,scaleX:1.38,scaleY:1.1,skewX:-7.2,skewY:160.4,x:-50.9,y:5.3},0).wait(2).to({regY:-1.9,scaleX:1.38,scaleY:1.1,skewX:-7.1,skewY:160.5,x:-50.8,y:5.2},0).wait(2).to({regY:-1.8,scaleX:1.38,scaleY:1.1,skewX:-7.2,skewY:160.4,x:-50.9,y:5.3},0).wait(2).to({scaleX:1.26,scaleY:1.01,skewX:-12.8,skewY:176.3,x:-50.5,y:5.2},0).wait(2).to({regX:-7.3,regY:-2,scaleX:1.17,scaleY:1.05,skewX:-17.1,skewY:167.5,x:-50.1,y:5.1},0).wait(2).to({regX:-7.1,regY:-1.9,scaleX:1.08,scaleY:1.08,skewX:-21.5,skewY:158.5,x:-49.6,y:5.3},0).wait(14).to({regX:-7.4,regY:-1.7,scaleX:1.23,scaleY:1.09,skewX:-14.3,skewY:159.5,x:-49.8,y:5.4},0).wait(2).to({regX:-7.2,regY:-1.8,scaleX:1.38,scaleY:1.1,skewX:-7.2,skewY:160.4,x:-50.9,y:5.3},0).wait(2).to({regY:-1.9,scaleX:1.38,scaleY:1.1,skewX:-7.1,skewY:160.5,x:-50.8,y:5.2},0).wait(2).to({regY:-1.8,scaleX:1.38,scaleY:1.1,skewX:-7.2,skewY:160.4,x:-50.9,y:5.3},0).wait(2).to({scaleX:1.26,scaleY:1.01,skewX:-12.8,skewY:176.3,x:-50.5,y:5.2},0).wait(2).to({regX:-7.3,regY:-2,scaleX:1.17,scaleY:1.05,skewX:-17.1,skewY:167.5,x:-50.1,y:5.1},0).wait(2).to({regX:-7.1,regY:-1.9,scaleX:1.08,scaleY:1.08,skewX:-21.5,skewY:158.5,x:-49.6,y:5.3},0).wait(2).to({regX:-7.2,scaleX:1.08,scaleY:1.08,skewX:-12.5,skewY:167.5,x:-50,y:5.6},0).wait(2).to({regX:-7.1,skewX:-3.8,skewY:176.2,x:-50.7,y:5.9},0).wait(2).to({regX:-8.2,regY:-1.1,scaleX:1.08,scaleY:1.08,skewX:5,skewY:185,x:-51.2,y:6.2},0).wait(52).to({regX:-7.1,regY:-1.9,skewX:-21.5,skewY:158.5,x:-49.6,y:5.3},0).wait(2).to({regX:-7,scaleX:1.08,scaleY:1.08,skewX:-22,skewY:158,x:-49.7,y:6.2},0).wait(2).to({regX:-7.2,regY:-1.8,skewX:-22.6,skewY:157.4,x:-49.6,y:7},0).wait(2).to({regX:-7,regY:-2,scaleX:1.08,scaleY:1.08,skewX:-23.2,skewY:156.8,x:-49.8,y:7.9},0).wait(2).to({scaleX:1.08,scaleY:1.08,skewX:-15.3,skewY:164.7,x:-50.6,y:6.1},0).wait(2).to({skewX:-7.6,skewY:172.4,x:-51.5,y:4.4},0).wait(2).to({regX:-7.1,regY:-1.9,scaleX:1.08,scaleY:1.08,skewX:0,skewY:180,x:-52.3,y:2.6},0).wait(337).to({regX:-7.5,skewX:-2,skewY:178,x:-55.5,y:9.6},0).wait(2).to({regX:-7.2,skewX:-2.7,skewY:177.3,x:-57.1,y:12},0).wait(2).to({skewX:-1.3,skewY:178.7,x:-54.7,y:7.3},0).wait(2).to({regX:-7.1,skewX:0,skewY:180,x:-52.3,y:2.6},0).wait(2).to({regX:-7.5,regY:-1.8,scaleX:1.08,scaleY:1.08,skewX:17.8,skewY:197.8,x:-50.1,y:-2},0).wait(2).to({regX:-7.2,regY:-1.9,scaleX:1.08,scaleY:1.08,skewX:35.8,skewY:215.8,x:-48.5,y:-7.1},0).wait(2).to({regX:-7.4,regY:-1.8,scaleX:1.08,scaleY:1.08,skewX:53.8,skewY:233.8,x:-46.8,y:-12},0).wait(2).to({regX:-7.2,regY:-1.7,scaleX:1.05,scaleY:1.08,skewX:53.9,skewY:233.9,x:-46.6,y:-11.7},0).wait(2).to({regX:-7.4,regY:-1.8,scaleX:1.02,x:-46,y:-11.2},0).wait(2).to({regX:-7.8,regY:-1.9,scaleX:1,scaleY:1.08,skewX:53.8,skewY:233.8,x:-45.6,y:-10.9},0).wait(2).to({scaleX:1.02,scaleY:1.08,skewX:53.9,skewY:233.9,x:-45.9,y:-11.3},0).wait(2).to({scaleX:1.05,x:-46.3,y:-11.6},0).wait(2).to({regX:-7.4,regY:-1.8,scaleX:1.08,scaleY:1.08,skewX:53.8,skewY:233.8,x:-46.8,y:-12},0).wait(2).to({regX:-7.2,regY:-1.7,scaleX:1.05,scaleY:1.08,skewX:53.9,skewY:233.9,x:-46.6,y:-11.7},0).wait(2).to({regX:-7.4,regY:-1.8,scaleX:1.02,x:-46,y:-11.2},0).wait(2).to({regX:-7.8,regY:-1.9,scaleX:1,scaleY:1.08,skewX:53.8,skewY:233.8,x:-45.6,y:-10.9},0).wait(2).to({scaleX:1.02,scaleY:1.08,skewX:53.9,skewY:233.9,x:-45.9,y:-11.3},0).wait(2).to({scaleX:1.05,x:-46.3,y:-11.6},0).wait(2).to({regX:-7.4,regY:-1.8,scaleX:1.08,scaleY:1.08,skewX:53.8,skewY:233.8,x:-46.8,y:-12},0).wait(24).to({regX:-7.3,regY:-1.9,scaleX:1.08,scaleY:1.08,skewX:41.6,skewY:221.6,x:-48.2,y:-11.3},0).wait(2).to({regX:-7.2,regY:-1.7,scaleX:1.08,scaleY:1.08,skewX:29.5,skewY:209.5,x:-49.8,y:-10.4},0).wait(2).to({regX:-6.7,regY:-0.8,skewX:14.8,skewY:194.8,x:-51.9,y:-3.1},0).wait(2).to({regX:-7.1,regY:-1.9,scaleX:1.08,scaleY:1.08,skewX:0,skewY:180,x:-52.3,y:2.6},0).wait(2).to({regX:-7.2,regY:1.6,skewX:-1.3,skewY:178.7,x:-56.7,y:11.9},0).wait(2).to({regX:-7.4,regY:0.5,skewX:-0.5,skewY:179.5,x:-54.2,y:6.6},0).wait(2).to({regX:-7.1,regY:-1.9,skewX:0,skewY:180,x:-52.3,y:2.6},0).wait(66).to({regX:-7.5,skewX:-2,skewY:178,x:-55.5,y:9.6},0).wait(2).to({regX:-7.2,skewX:-2.7,skewY:177.3,x:-57.1,y:12},0).wait(2).to({skewX:-1.3,skewY:178.7,x:-54.7,y:7.3},0).wait(2).to({regX:-7.1,skewX:0,skewY:180,x:-52.3,y:2.6},0).wait(2).to({regX:-7.5,regY:-1.8,scaleX:1.08,scaleY:1.08,skewX:17.8,skewY:197.8,x:-50.1,y:-2},0).wait(2).to({regX:-7.2,regY:-1.9,scaleX:1.08,scaleY:1.08,skewX:35.8,skewY:215.8,x:-48.5,y:-7.1},0).wait(2).to({regX:-7.4,regY:-1.8,scaleX:1.08,scaleY:1.08,skewX:53.8,skewY:233.8,x:-46.8,y:-12},0).wait(2).to({regX:-7.2,regY:-1.7,scaleX:1.05,scaleY:1.08,skewX:53.9,skewY:233.9,x:-46.6,y:-11.7},0).wait(2).to({regX:-7.4,regY:-1.8,scaleX:1.02,x:-46,y:-11.2},0).wait(2).to({regX:-7.8,regY:-1.9,scaleX:1,scaleY:1.08,skewX:53.8,skewY:233.8,x:-45.6,y:-10.9},0).wait(2).to({scaleX:1.02,scaleY:1.08,skewX:53.9,skewY:233.9,x:-45.9,y:-11.3},0).wait(2).to({scaleX:1.05,x:-46.3,y:-11.6},0).wait(2).to({regX:-7.4,regY:-1.8,scaleX:1.08,scaleY:1.08,skewX:53.8,skewY:233.8,x:-46.8,y:-12},0).wait(4).to({regX:-7.3,regY:-1.9,scaleX:1.08,scaleY:1.08,skewX:41.6,skewY:221.6,x:-48.2,y:-11.3},0).wait(2).to({regX:-7.2,regY:-1.7,scaleX:1.08,scaleY:1.08,skewX:29.5,skewY:209.5,x:-49.8,y:-10.4},0).wait(2).to({regX:-6.7,regY:-0.8,skewX:14.8,skewY:194.8,x:-51.9,y:-3.1},0).wait(2).to({regX:-7.1,regY:-1.9,scaleX:1.08,scaleY:1.08,skewX:0,skewY:180,x:-52.3,y:2.6},0).wait(2).to({regX:-7.2,regY:1.7,skewX:-1.3,skewY:178.7,x:-56.7,y:12},0).wait(2).to({regX:-7.4,regY:0.5,skewX:-0.5,skewY:179.5,x:-54.2,y:6.6},0).wait(2).to({regX:-7.1,regY:-1.9,skewX:0,skewY:180,x:-52.3,y:2.6},0).to({_off:true},4).wait(31));

	// Pig Hind Leg
	this.pig_hindleg = new lib.PigHindLeg();
	this.pig_hindleg.parent = this;
	this.pig_hindleg.setTransform(41.7,18.2,1.082,1.082,0,0,180);

	this.timeline.addTween(cjs.Tween.get(this.pig_hindleg).wait(112).to({x:41.6},0).wait(8).to({x:41.7},0).wait(2).to({x:41.6},0).wait(6).to({x:41.7},0).wait(2).to({x:41.6},0).wait(2).to({x:41.7},0).wait(2).to({x:41.6},0).wait(8).to({x:41.7},0).wait(18).to({x:41.6},0).wait(4).to({x:41.7},0).wait(2).to({x:41.6},0).wait(8).to({x:41.7},0).wait(2).to({x:41.6},0).wait(4).to({x:41.7},0).wait(2).to({x:41.6},0).wait(2).to({x:41.7},0).wait(2).to({x:41.6},0).wait(2).to({x:41.7},0).wait(2).to({x:41.6},0).wait(4).to({x:41.7},0).wait(14).to({x:41.6},0).wait(2).to({x:41.7},0).wait(2).to({x:41.6},0).wait(2).to({x:41.7},0).wait(2).to({x:41.6},0).wait(4).to({x:41.7},0).wait(60).to({x:41.6},0).wait(4).to({x:41.7},0).wait(2).to({x:41.6},0).wait(4).to({x:41.7},0).wait(337).to({scaleY:1.02,skewX:-2.5,x:39.9,y:20.5},0).wait(2).to({scaleY:1,skewX:-3.4,x:39.4,y:21.3},0).wait(2).to({scaleY:1.04,skewX:-1.6,x:40.5,y:19.8},0).wait(2).to({scaleY:1.08,skewX:0,x:41.7,y:18.2},0).wait(2).to({scaleY:1.06,skewX:-0.6,x:41.1,y:19},0).wait(2).to({scaleY:1.04,skewX:-1.3,x:40.6,y:19.9},0).wait(2).to({scaleY:1.02,skewX:-2.1,x:40.2,y:20.7},0).wait(48).to({scaleY:1.05,skewX:-1.5,x:40.5,y:19.6},0).wait(2).to({scaleY:1.07,skewX:-0.9,x:40.9,y:18.5},0).wait(2).to({scaleY:1.08,skewX:0,x:41.5,y:18.4},0).wait(2).to({scaleY:1.08,skewX:0.6,x:42.1,y:18.2},0).wait(2).to({scaleY:1.05,skewX:-2.8,x:39.8,y:19.7},0).wait(2).to({scaleY:1.06,skewX:-1.3,x:40.7,y:19},0).wait(2).to({scaleY:1.08,skewX:0,x:41.7,y:18.2},0).wait(66).to({scaleY:1.02,skewX:-2.5,x:39.9,y:20.5},0).wait(2).to({scaleY:1,skewX:-3.4,x:39.4,y:21.3},0).wait(2).to({scaleY:1.04,skewX:-1.6,x:40.5,y:19.8},0).wait(2).to({scaleY:1.08,skewX:0,x:41.7,y:18.2},0).wait(2).to({scaleY:1.06,skewX:-0.6,x:41.1,y:19},0).wait(2).to({scaleY:1.04,skewX:-1.3,x:40.6,y:19.9},0).wait(2).to({scaleY:1.02,skewX:-2.1,x:40.2,y:20.7},0).wait(16).to({scaleY:1.05,skewX:-1.5,x:40.5,y:19.6},0).wait(2).to({scaleY:1.07,skewX:-0.9,x:40.9,y:18.5},0).wait(2).to({scaleY:1.08,skewX:0,x:41.5,y:18.4},0).wait(2).to({scaleY:1.08,skewX:0.6,x:42.1,y:18.2},0).wait(2).to({scaleY:1.05,skewX:-2.8,x:39.8,y:19.7},0).wait(2).to({scaleY:1.06,skewX:-1.3,x:40.7,y:19},0).wait(2).to({scaleY:1.08,skewX:0,x:41.7,y:18.2},0).to({_off:true},4).wait(31));

	// Pig Torso
	this.pig_torso = new lib.PigTorso();
	this.pig_torso.parent = this;
	this.pig_torso.setTransform(-2,-2.8,1.082,1.082,0,0,180);

	this.pig_torso_1 = new lib.PigTorso_excited_001();
	this.pig_torso_1.parent = this;
	this.pig_torso_1.setTransform(-2,-2.8,1.082,1.082,0,0,180);
	this.pig_torso_1._off = true;

	this.pig_torso_2 = new lib.PigTorso_excited_002();
	this.pig_torso_2.parent = this;
	this.pig_torso_2.setTransform(-4.9,-5.3,1.082,1.082,0,2.8,-177.2);

	this.pig_torso_3 = new lib.PigTorso_excited_003();
	this.pig_torso_3.parent = this;
	this.pig_torso_3.setTransform(-6.5,-6.5,1.082,1.082,0,4.4,-175.6);
	this.pig_torso_3._off = true;

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.pig_torso}]}).to({state:[{t:this.pig_torso}]},30).to({state:[{t:this.pig_torso}]},56).to({state:[{t:this.pig_torso}]},24).to({state:[{t:this.pig_torso}]},2).to({state:[{t:this.pig_torso}]},2).to({state:[{t:this.pig_torso}]},2).to({state:[{t:this.pig_torso}]},2).to({state:[{t:this.pig_torso}]},2).to({state:[{t:this.pig_torso}]},2).to({state:[{t:this.pig_torso}]},2).to({state:[{t:this.pig_torso}]},2).to({state:[{t:this.pig_torso}]},2).to({state:[{t:this.pig_torso}]},2).to({state:[{t:this.pig_torso}]},2).to({state:[{t:this.pig_torso}]},2).to({state:[{t:this.pig_torso}]},2).to({state:[{t:this.pig_torso}]},2).to({state:[{t:this.pig_torso}]},2).to({state:[{t:this.pig_torso}]},2).to({state:[{t:this.pig_torso}]},16).to({state:[{t:this.pig_torso}]},2).to({state:[{t:this.pig_torso}]},2).to({state:[{t:this.pig_torso}]},2).to({state:[{t:this.pig_torso}]},2).to({state:[{t:this.pig_torso}]},2).to({state:[{t:this.pig_torso}]},2).to({state:[{t:this.pig_torso}]},2).to({state:[{t:this.pig_torso}]},2).to({state:[{t:this.pig_torso}]},2).to({state:[{t:this.pig_torso}]},2).to({state:[{t:this.pig_torso}]},2).to({state:[{t:this.pig_torso}]},2).to({state:[{t:this.pig_torso}]},2).to({state:[{t:this.pig_torso}]},2).to({state:[{t:this.pig_torso}]},2).to({state:[{t:this.pig_torso}]},2).to({state:[{t:this.pig_torso}]},2).to({state:[{t:this.pig_torso}]},2).to({state:[{t:this.pig_torso}]},12).to({state:[{t:this.pig_torso}]},2).to({state:[{t:this.pig_torso}]},2).to({state:[{t:this.pig_torso}]},2).to({state:[{t:this.pig_torso}]},2).to({state:[{t:this.pig_torso}]},2).to({state:[{t:this.pig_torso}]},2).to({state:[{t:this.pig_torso}]},2).to({state:[{t:this.pig_torso}]},58).to({state:[{t:this.pig_torso}]},2).to({state:[{t:this.pig_torso}]},2).to({state:[{t:this.pig_torso}]},2).to({state:[{t:this.pig_torso}]},2).to({state:[{t:this.pig_torso}]},2).to({state:[{t:this.pig_torso}]},2).to({state:[{t:this.pig_torso}]},10).to({state:[{t:this.pig_torso}]},16).to({state:[{t:this.pig_torso}]},300).to({state:[{t:this.pig_torso_1}]},1).to({state:[{t:this.pig_torso_1}]},8).to({state:[{t:this.pig_torso_1}]},2).to({state:[{t:this.pig_torso_1}]},2).to({state:[{t:this.pig_torso_1}]},2).to({state:[{t:this.pig_torso_1}]},2).to({state:[{t:this.pig_torso_1}]},2).to({state:[{t:this.pig_torso_2}]},2).to({state:[{t:this.pig_torso_3}]},2).to({state:[{t:this.pig_torso_3}]},46).to({state:[{t:this.pig_torso_3}]},2).to({state:[{t:this.pig_torso_1}]},2).to({state:[{t:this.pig_torso_1}]},2).to({state:[{t:this.pig_torso_1}]},2).to({state:[{t:this.pig_torso_1}]},2).to({state:[{t:this.pig_torso_1}]},2).to({state:[{t:this.pig_torso_1}]},2).to({state:[{t:this.pig_torso_1}]},61).to({state:[{t:this.pig_torso_1}]},3).to({state:[{t:this.pig_torso_1}]},2).to({state:[{t:this.pig_torso_1}]},2).to({state:[{t:this.pig_torso_1}]},2).to({state:[{t:this.pig_torso_1}]},2).to({state:[{t:this.pig_torso_1}]},2).to({state:[{t:this.pig_torso_2}]},2).to({state:[{t:this.pig_torso_3}]},2).to({state:[{t:this.pig_torso_3}]},14).to({state:[{t:this.pig_torso_3}]},2).to({state:[{t:this.pig_torso_1}]},2).to({state:[{t:this.pig_torso_1}]},2).to({state:[{t:this.pig_torso_1}]},2).to({state:[{t:this.pig_torso_1}]},2).to({state:[{t:this.pig_torso_1}]},2).to({state:[{t:this.pig_torso_1}]},2).to({state:[]},4).wait(31));
	this.timeline.addTween(cjs.Tween.get(this.pig_torso).wait(112).to({skewX:-0.5,skewY:179.5},0).wait(2).to({skewX:-1,skewY:179},0).wait(2).to({skewX:-1.8,skewY:178.2},0).wait(2).to({skewX:-2.3,skewY:177.7},0).wait(2).to({skewX:-3,skewY:177},0).wait(2).to({scaleX:1.09,skewX:-2.8,skewY:176.4,x:-3.1,y:-2.1},0).wait(2).to({scaleX:1.09,skewY:175.7,x:-4.2,y:-1.4},0).wait(2).to({scaleX:1.1,skewY:175,x:-5.3,y:-0.8},0).wait(2).to({scaleX:1.11,skewX:-3,skewY:174.1,x:-6.5,y:-0.1},0).wait(2).to({skewX:-2.8,skewY:174.2,x:-6.6},0).wait(2).to({skewX:-3,skewY:174.1,x:-6.5},0).wait(2).to({scaleX:1.1,skewX:-2.8,skewY:174.7,x:-5.7,y:-0.7},0).wait(2).to({scaleX:1.1,skewY:175.4,x:-4.8,y:-1.2},0).wait(2).to({scaleX:1.09,skewY:176,x:-3.8,y:-1.7},0).wait(2).to({scaleX:1.09,skewY:176.5,x:-2.9,y:-2.3},0).wait(2).to({scaleX:1.08,skewX:-3,skewY:177,x:-2,y:-2.8},0).wait(18).to({skewX:-1.8,skewY:178.2},0).wait(2).to({skewX:-0.8,skewY:179.2,x:-1.9},0).wait(2).to({skewX:0,skewY:180,x:-2},0).wait(12).to({skewX:-0.8,skewY:179.2},0).wait(2).to({skewX:-1.8,skewY:178.2},0).wait(2).to({skewX:-3,skewY:177},0).wait(2).to({scaleX:1.09,skewX:-2.8,skewY:175.7,x:-4.2,y:-1.4},0).wait(2).to({scaleX:1.11,skewX:-3,skewY:174.1,x:-6.5,y:-0.1},0).wait(2).to({skewX:-2.8,skewY:174.2,x:-6.6},0).wait(2).to({skewX:-3,skewY:174.1,x:-6.5},0).wait(2).to({scaleX:1.1,skewX:-2.8,skewY:175.2,x:-5,y:-1},0).wait(2).to({scaleX:1.09,skewY:176.2,x:-3.5,y:-1.9},0).wait(2).to({scaleX:1.08,skewX:-3,skewY:177,x:-2,y:-2.8},0).wait(14).to({scaleX:1.09,skewX:-2.8,skewY:175.7,x:-4.2,y:-1.4},0).wait(2).to({scaleX:1.11,skewX:-3,skewY:174.1,x:-6.5,y:-0.1},0).wait(2).to({skewX:-2.8,skewY:174.2,x:-6.6},0).wait(2).to({skewX:-3,skewY:174.1,x:-6.5},0).wait(2).to({scaleX:1.1,skewX:-2.8,skewY:175.2,x:-5,y:-1},0).wait(2).to({scaleX:1.09,skewY:176.2,x:-3.5,y:-1.9},0).wait(2).to({scaleX:1.08,skewX:-3,skewY:177,x:-2,y:-2.8},0).wait(60).to({scaleX:1.08,scaleY:1.08,skewX:-3.5,skewY:176.5,y:-2.4},0).wait(2).to({skewX:-4,skewY:176,x:-2.2,y:-2},0).wait(2).to({scaleX:1.08,scaleY:1.08,skewX:-4.7,skewY:175.3,x:-2.3,y:-1.5},0).wait(2).to({skewX:-3,skewY:177,x:-2.2,y:-1.9},0).wait(2).to({skewX:-1.5,skewY:178.5,x:-2.1,y:-2.4},0).wait(2).to({skewX:0,skewY:180,x:-2,y:-2.8},0).wait(326).to({_off:true},1).wait(223));
	this.timeline.addTween(cjs.Tween.get(this.pig_torso_1).wait(617).to({_off:false},0).wait(10).to({skewX:-2,skewY:178,x:-4.9,y:2.5},0).wait(2).to({skewX:-2.7,skewY:177.3,x:-5.9,y:4.3},0).wait(2).to({skewX:-1.3,skewY:178.7,x:-3.9,y:0.7},0).wait(2).to({skewX:0,skewY:180,x:-2,y:-2.8},0).wait(2).to({skewX:1.3,skewY:181.3,x:-3.4,y:-4.1},0).to({_off:true},2).wait(52).to({_off:false,scaleX:1.08,scaleY:1.08,skewX:4.5,skewY:184.5,x:-4.2,y:-8.1},0).wait(2).to({skewX:2.1,skewY:182.1,x:-3.1,y:-5.5},0).wait(2).to({scaleX:1.08,scaleY:1.08,skewX:0,skewY:180,x:-2,y:-2.8},0).wait(2).to({skewX:-1.3,skewY:178.7,x:-6,y:1.4},0).wait(2).to({skewX:-0.5,skewY:179.5,x:-3.9,y:-0.7},0).wait(2).to({skewX:0,skewY:180,x:-2,y:-2.8},0).wait(66).to({skewX:-2,skewY:178,x:-4.9,y:2.5},0).wait(2).to({skewX:-2.7,skewY:177.3,x:-5.9,y:4.3},0).wait(2).to({skewX:-1.3,skewY:178.7,x:-3.9,y:0.7},0).wait(2).to({skewX:0,skewY:180,x:-2,y:-2.8},0).wait(2).to({skewX:1.3,skewY:181.3,x:-3.4,y:-4.1},0).to({_off:true},2).wait(20).to({_off:false,scaleX:1.08,scaleY:1.08,skewX:4.5,skewY:184.5,x:-4.2,y:-8.1},0).wait(2).to({skewX:2.1,skewY:182.1,x:-3.1,y:-5.5},0).wait(2).to({scaleX:1.08,scaleY:1.08,skewX:0,skewY:180,x:-2,y:-2.8},0).wait(2).to({skewX:-1.3,skewY:178.7,x:-6,y:1.4},0).wait(2).to({skewX:-0.5,skewY:179.5,x:-3.9,y:-0.7},0).wait(2).to({skewX:0,skewY:180,x:-2,y:-2.8},0).to({_off:true},4).wait(31));
	this.timeline.addTween(cjs.Tween.get(this.pig_torso_3).wait(639).to({_off:false},0).wait(48).to({scaleX:1.08,scaleY:1.08,skewX:4.3,skewY:-175.7,x:-5.3,y:-7.3},0).to({_off:true},2).wait(88).to({_off:false,scaleX:1.08,scaleY:1.08,skewX:4.4,skewY:-175.6,x:-6.5,y:-6.5},0).wait(16).to({scaleX:1.08,scaleY:1.08,skewX:4.3,skewY:-175.7,x:-5.3,y:-7.3},0).to({_off:true},2).wait(45));

	// Pig Tail 2
	this.instance_6 = new lib.PigTail2();
	this.instance_6.parent = this;
	this.instance_6.setTransform(66.2,-9.3,1.31,1.31,0,11,-169,11.2,3);

	this.instance_7 = new lib.PigTail_excited_002();
	this.instance_7.parent = this;
	this.instance_7.setTransform(52.4,-7.4,1.31,1.31,0,19.9,-160.1,15.5,8.2);
	this.instance_7._off = true;

	this.instance_8 = new lib.PigTail_excited_003();
	this.instance_8.parent = this;
	this.instance_8.setTransform(51.7,-8.3,1.31,1.31,0,24.9,-155.1,15.3,8);
	this.instance_8._off = true;

	this.timeline.addTween(cjs.Tween.get(this.instance_6).wait(112).to({scaleX:1.31,scaleY:1.31,skewX:10.8,skewY:-169.2,x:65.9,y:-10.3},0).wait(2).to({regY:3.4,x:65.4,y:-10.8},0).wait(2).to({regX:11.3,regY:3.8,x:64.9,y:-11.2},0).wait(2).to({regX:11.2,regY:3.1,y:-13.1},0).wait(2).to({regX:11.3,regY:3,scaleX:1.31,scaleY:1.31,skewX:11,skewY:-169,x:64.7,y:-14.2},0).wait(2).to({regX:11,scaleX:1.31,scaleY:1.31,skewX:10.8,skewY:-169.2,x:65},0).wait(6).to({regX:11.3,scaleX:1.31,scaleY:1.31,skewX:11,skewY:-169,x:64.7},0).wait(2).to({regX:11,scaleX:1.31,scaleY:1.31,skewX:10.8,skewY:-169.2,x:65},0).wait(2).to({regX:11.3,scaleX:1.31,scaleY:1.31,skewX:11,skewY:-169,x:64.7},0).wait(2).to({regX:11,scaleX:1.31,scaleY:1.31,skewX:10.8,skewY:-169.2,x:65},0).wait(8).to({regX:11.3,scaleX:1.31,scaleY:1.31,skewX:11,skewY:-169,x:64.7},0).wait(18).to({scaleX:1.31,scaleY:1.31,skewX:10.8,skewY:-169.2,x:65.2,y:-12.6},0).wait(2).to({x:65.7,y:-11},0).wait(2).to({regX:11.2,scaleX:1.31,scaleY:1.31,skewX:11,skewY:-169,x:66.2,y:-9.3},0).wait(2).to({scaleX:1.31,scaleY:1.31,skewX:10.8,skewY:-169.2},0).wait(8).to({scaleX:1.31,scaleY:1.31,skewX:11,skewY:-169},0).wait(2).to({scaleX:1.31,scaleY:1.31,skewX:10.8,skewY:-169.2,x:65.6,y:-11},0).wait(2).to({x:65.1,y:-12.6},0).wait(2).to({regX:11.3,scaleX:1.31,scaleY:1.31,skewX:11,skewY:-169,x:64.7,y:-14.2},0).wait(2).to({regX:11,scaleX:1.31,scaleY:1.31,skewX:10.8,skewY:-169.2,x:65},0).wait(2).to({regX:11.3,scaleX:1.31,scaleY:1.31,skewX:11,skewY:-169,x:64.7},0).wait(2).to({regX:11,scaleX:1.31,scaleY:1.31,skewX:10.8,skewY:-169.2,x:65},0).wait(2).to({regX:11.3,scaleX:1.31,scaleY:1.31,skewX:11,skewY:-169,x:64.7},0).wait(2).to({regX:11,scaleX:1.31,scaleY:1.31,skewX:10.8,skewY:-169.2,x:65},0).wait(4).to({regX:11.3,scaleX:1.31,scaleY:1.31,skewX:11,skewY:-169,x:64.7},0).wait(14).to({regX:11,scaleX:1.31,scaleY:1.31,skewX:10.8,skewY:-169.2,x:65},0).wait(2).to({regX:11.3,scaleX:1.31,scaleY:1.31,skewX:11,skewY:-169,x:64.7},0).wait(2).to({regX:11,scaleX:1.31,scaleY:1.31,skewX:10.8,skewY:-169.2,x:65},0).wait(2).to({regX:11.3,scaleX:1.31,scaleY:1.31,skewX:11,skewY:-169,x:64.7},0).wait(2).to({regX:11,scaleX:1.31,scaleY:1.31,skewX:10.8,skewY:-169.2,x:65},0).wait(4).to({regX:11.3,scaleX:1.31,scaleY:1.31,skewX:11,skewY:-169,x:64.7},0).wait(60).to({regX:11,scaleX:1.31,scaleY:1.31,skewX:10.8,skewY:-169.2,x:65},0).wait(4).to({regX:11.3,scaleX:1.31,scaleY:1.31,skewX:11,skewY:-169,x:64.7},0).wait(2).to({scaleX:1.31,scaleY:1.31,skewX:10.8,skewY:-169.2,x:65.2,y:-12.6},0).wait(2).to({x:65.7,y:-11},0).wait(2).to({regX:11.2,scaleX:1.31,scaleY:1.31,skewX:11,skewY:-169,x:66.2,y:-9.3},0).wait(337).to({regX:11.4,regY:3.4,scaleX:1.31,scaleY:1.31,skewX:8.8,skewY:-171.2,x:61.6,y:-6},0).wait(2).to({regX:11.2,regY:3,scaleX:1.31,scaleY:1.31,skewX:8.3,skewY:-171.7,x:60.6,y:-5.5},0).wait(2).to({regY:3.1,scaleX:1.31,scaleY:1.31,skewX:9.5,skewY:-170.5,x:63.4,y:-7.3},0).wait(2).to({regY:3,scaleX:1.31,scaleY:1.31,skewX:11,skewY:-169,x:66.2,y:-9.3},0).wait(2).to({regX:11.1,scaleX:1.31,scaleY:1.31,skewX:8.3,skewY:-171.7,x:63.7,y:-10.8},0).wait(2).to({regX:11.2,scaleX:1.31,scaleY:1.31,skewX:5.8,skewY:-174.2,x:60.8,y:-12.2},0).wait(2).to({regX:11.3,regY:3.3,skewX:3.2,skewY:-176.8,x:58.3,y:-13.6},0).to({_off:true},2).wait(18).to({_off:false},0).wait(6).to({_off:true},2).wait(18).to({_off:false},0).wait(2).to({regX:12.2,regY:3.7,scaleX:1.31,scaleY:1.31,skewX:6.3,skewY:-173.7,x:59.1,y:-12.4},0).wait(2).to({regX:11.5,regY:3.2,skewX:9.7,skewY:-170.3,x:62.3,y:-12.1},0).wait(2).to({skewX:10.3,skewY:-169.7,x:64.3,y:-10.8},0).wait(2).to({regX:11.2,regY:3,scaleX:1.31,scaleY:1.31,skewX:11,skewY:-169,x:66.2,y:-9.3},0).wait(2).to({regX:11.1,regY:2.9,scaleX:1.31,scaleY:1.31,skewX:9.5,skewY:-170.5,x:63.8,y:-6.7},0).wait(2).to({skewX:10.1,skewY:-169.9,x:65,y:-8},0).wait(2).to({regX:11.2,regY:3,scaleX:1.31,scaleY:1.31,skewX:11,skewY:-169,x:66.2,y:-9.3},0).wait(66).to({regX:11.4,regY:3.4,scaleX:1.31,scaleY:1.31,skewX:8.8,skewY:-171.2,x:61.6,y:-6},0).wait(2).to({regX:11.2,regY:3,scaleX:1.31,scaleY:1.31,skewX:8.3,skewY:-171.7,x:60.6,y:-5.5},0).wait(2).to({regY:3.1,scaleX:1.31,scaleY:1.31,skewX:9.5,skewY:-170.5,x:63.4,y:-7.3},0).wait(2).to({regY:3,scaleX:1.31,scaleY:1.31,skewX:11,skewY:-169,x:66.2,y:-9.3},0).wait(2).to({regX:11.1,scaleX:1.31,scaleY:1.31,skewX:8.3,skewY:-171.7,x:63.7,y:-10.8},0).wait(2).to({regX:11.2,scaleX:1.31,scaleY:1.31,skewX:5.8,skewY:-174.2,x:60.8,y:-12.2},0).wait(2).to({regX:11.3,regY:3.3,skewX:3.2,skewY:-176.8,x:58.3,y:-13.6},0).to({_off:true},2).wait(12).to({_off:false},0).wait(2).to({regX:12.3,regY:3.8,scaleX:1.31,scaleY:1.31,skewX:6.3,skewY:-173.7,x:59,y:-12.3},0).wait(2).to({regX:11.5,regY:3.2,skewX:9.7,skewY:-170.3,x:62.3,y:-12.1},0).wait(2).to({skewX:10.3,skewY:-169.7,x:64.3,y:-10.8},0).wait(2).to({regX:11.2,regY:3,scaleX:1.31,scaleY:1.31,skewX:11,skewY:-169,x:66.2,y:-9.3},0).wait(2).to({regX:11.1,regY:2.9,scaleX:1.31,scaleY:1.31,skewX:9.5,skewY:-170.5,x:63.8,y:-6.7},0).wait(2).to({skewX:10.1,skewY:-169.9,x:65,y:-8},0).wait(2).to({regX:11.2,regY:3,scaleX:1.31,scaleY:1.31,skewX:11,skewY:-169,x:66.2,y:-9.3},0).to({_off:true},4).wait(31));
	this.timeline.addTween(cjs.Tween.get(this.instance_7).wait(641).to({_off:false},0).to({_off:true},2).wait(12).to({_off:false},0).wait(2).to({regX:15.7,regY:8.1,skewX:11.7,skewY:-168.3,x:52.2,y:-7.6},0).to({_off:true},2).wait(8).to({_off:false,regX:15.5,regY:8.2,skewX:19.9,skewY:-160.1,x:52.4,y:-7.4},0).to({_off:true},2).wait(12).to({_off:false},0).wait(2).to({regX:15.7,regY:8.1,skewX:11.7,skewY:-168.3,x:52.2,y:-7.6},0).to({_off:true},2).wait(94).to({_off:false,regX:15.5,regY:8.2,skewX:19.9,skewY:-160.1,x:52.4,y:-7.4},0).to({_off:true},2).wait(59));
	this.timeline.addTween(cjs.Tween.get(this.instance_8).wait(643).to({_off:false},0).wait(2).to({scaleX:1.31,scaleY:1.31,skewX:20.5,skewY:-159.5,x:51.5,y:-8.6},0).wait(2).to({regX:15.7,regY:7.7,scaleX:1.31,scaleY:1.31,skewX:16.2,skewY:-163.8,x:51.3,y:-8.9},0).wait(2).to({scaleX:1.31,scaleY:1.31,skewX:20.5,skewY:-159.5,x:51.5,y:-8.6},0).wait(2).to({regX:15.3,regY:8,scaleX:1.31,scaleY:1.31,skewX:24.9,skewY:-155.1,x:51.7,y:-8.3},0).to({_off:true},4).wait(14).to({_off:false},0).wait(2).to({scaleX:1.31,scaleY:1.31,skewX:20.5,skewY:-159.5,x:51.5,y:-8.6},0).wait(2).to({regX:15.7,regY:7.7,scaleX:1.31,scaleY:1.31,skewX:16.2,skewY:-163.8,x:51.3,y:-8.9},0).wait(2).to({scaleX:1.31,scaleY:1.31,skewX:20.5,skewY:-159.5,x:51.5,y:-8.6},0).wait(2).to({regX:15.3,regY:8,scaleX:1.31,scaleY:1.31,skewX:24.9,skewY:-155.1,x:51.7,y:-8.3},0).to({_off:true},4).wait(100).to({_off:false},0).wait(2).to({scaleX:1.31,scaleY:1.31,skewX:20.5,skewY:-159.5,x:51.5,y:-8.6},0).wait(2).to({regX:15.7,regY:7.7,scaleX:1.31,scaleY:1.31,skewX:16.2,skewY:-163.8,x:51.3,y:-8.9},0).wait(2).to({scaleX:1.31,scaleY:1.31,skewX:20.5,skewY:-159.5,x:51.5,y:-8.6},0).wait(2).to({regX:15.3,regY:8,scaleX:1.31,scaleY:1.31,skewX:24.9,skewY:-155.1,x:51.7,y:-8.3},0).to({_off:true},2).wait(49));

	// Pig Hind Leg Back
	this.pig_hindlegback = new lib.PigHindLegBack();
	this.pig_hindlegback.parent = this;
	this.pig_hindlegback.setTransform(34.2,22.8,1.082,1.082,0,0,180);

	this.timeline.addTween(cjs.Tween.get(this.pig_hindlegback).wait(112).to({y:22.7},0).wait(8).to({y:22.8},0).wait(2).to({y:22.7},0).wait(6).to({y:22.8},0).wait(2).to({y:22.7},0).wait(2).to({y:22.8},0).wait(2).to({y:22.7},0).wait(8).to({y:22.8},0).wait(18).to({y:22.7},0).wait(4).to({y:22.8},0).wait(2).to({y:22.7},0).wait(8).to({y:22.8},0).wait(2).to({y:22.7},0).wait(4).to({y:22.8},0).wait(2).to({y:22.7},0).wait(2).to({y:22.8},0).wait(2).to({y:22.7},0).wait(2).to({y:22.8},0).wait(2).to({y:22.7},0).wait(4).to({y:22.8},0).wait(14).to({y:22.7},0).wait(2).to({y:22.8},0).wait(2).to({y:22.7},0).wait(2).to({y:22.8},0).wait(2).to({y:22.7},0).wait(4).to({y:22.8},0).wait(60).to({y:22.7},0).wait(4).to({y:22.8},0).wait(2).to({y:22.7},0).wait(4).to({y:22.8},0).wait(337).to({scaleY:1.02,skewX:-2.5,x:32.7,y:24.8},0).wait(2).to({scaleY:1,skewX:-3.4,x:32.1,y:25.5},0).wait(2).to({scaleY:1.04,skewX:-1.6,x:33.2,y:24.1},0).wait(2).to({scaleY:1.08,skewX:0,x:34.2,y:22.8},0).wait(2).to({scaleY:1.06,skewX:-0.6,x:33.8,y:23.5},0).wait(2).to({scaleY:1.04,skewX:-1.3,x:33.4,y:24.2},0).wait(2).to({scaleY:1.02,skewX:-2.1,x:32.9,y:25},0).wait(48).to({scaleY:1.05,skewX:-1.5,x:33.2,y:24},0).wait(2).to({scaleY:1.07,skewX:-0.9,x:33.5,y:23.1},0).wait(2).to({scaleY:1.08,skewX:0,x:34,y:22.9},0).wait(2).to({scaleY:1.08,skewX:0.6,x:34.6,y:22.8},0).wait(2).to({scaleY:1.05,skewX:-2.8,x:32.4,y:24.1},0).wait(2).to({scaleY:1.06,skewX:-1.3,x:33.3,y:23.5},0).wait(2).to({scaleY:1.08,skewX:0,x:34.2,y:22.8},0).wait(66).to({scaleY:1.02,skewX:-2.5,x:32.7,y:24.8},0).wait(2).to({scaleY:1,skewX:-3.4,x:32.1,y:25.5},0).wait(2).to({scaleY:1.04,skewX:-1.6,x:33.2,y:24.1},0).wait(2).to({scaleY:1.08,skewX:0,x:34.2,y:22.8},0).wait(2).to({scaleY:1.06,skewX:-0.6,x:33.8,y:23.5},0).wait(2).to({scaleY:1.04,skewX:-1.3,x:33.4,y:24.2},0).wait(2).to({scaleY:1.02,skewX:-2.1,x:32.9,y:25},0).wait(16).to({scaleY:1.05,skewX:-1.5,x:33.2,y:24},0).wait(2).to({scaleY:1.07,skewX:-0.9,x:33.5,y:23.1},0).wait(2).to({scaleY:1.08,skewX:0,x:34,y:22.9},0).wait(2).to({scaleY:1.08,skewX:0.6,x:34.6,y:22.8},0).wait(2).to({scaleY:1.05,skewX:-2.8,x:32.4,y:24.1},0).wait(2).to({scaleY:1.06,skewX:-1.3,x:33.3,y:23.5},0).wait(2).to({scaleY:1.08,skewX:0,x:34.2,y:22.8},0).to({_off:true},4).wait(31));

	// Pig Front Leg Back
	this.pig_frontlegback = new lib.PigFrontLegBack();
	this.pig_frontlegback.parent = this;
	this.pig_frontlegback.setTransform(-49.6,25.9,1.082,1.082,0,0,180);

	this.timeline.addTween(cjs.Tween.get(this.pig_frontlegback).wait(112).to({scaleY:1.07,skewX:1.8,x:-48.6,y:26.3},0).wait(2).to({scaleY:1.06,skewX:3.5,x:-47.7,y:26.6},0).wait(2).to({scaleY:1.05,skewX:5.3,x:-46.7,y:26.9},0).wait(2).to({scaleY:1.05,skewX:7.3,x:-45.7,y:27.3},0).wait(2).to({scaleY:1.04,skewX:9.2,x:-44.8,y:27.6},0).wait(2).to({scaleY:1.03,skewX:7.8,x:-45.4},0).wait(2).to({scaleY:1.03,skewX:6.6,x:-46},0).wait(2).to({scaleY:1.03,skewX:5.3,x:-46.6},0).wait(2).to({scaleY:1.03,skewX:4.3,x:-47.3},0).wait(6).to({scaleY:1.03,skewX:5.1,x:-46.8,y:27.7},0).wait(2).to({scaleY:1.03,skewX:6.1,x:-46.3},0).wait(2).to({scaleY:1.03,skewX:7.1,x:-45.8,y:27.6},0).wait(2).to({scaleY:1.03,skewX:8,x:-45.3},0).wait(2).to({scaleY:1.04,skewX:9.2,x:-44.8},0).wait(18).to({scaleY:1.05,skewX:6,x:-46.3,y:27.1},0).wait(2).to({scaleY:1.07,skewX:3,x:-47.9,y:26.5},0).wait(2).to({scaleY:1.08,skewX:0,x:-49.6,y:25.9},0).wait(12).to({scaleY:1.07,skewX:3,x:-48,y:26.5},0).wait(2).to({scaleY:1.05,skewX:6,x:-46.4,y:27},0).wait(2).to({scaleY:1.04,skewX:9.2,x:-44.8,y:27.6},0).wait(2).to({scaleY:1.03,skewX:6.6,x:-46},0).wait(2).to({scaleY:1.03,skewX:4.3,x:-47.3},0).wait(6).to({scaleY:1.03,skewX:5.8,x:-46.5},0).wait(2).to({scaleY:1.03,skewX:7.5,x:-45.6},0).wait(2).to({scaleY:1.04,skewX:9.2,x:-44.8},0).wait(14).to({scaleY:1.03,skewX:6.6,x:-46},0).wait(2).to({scaleY:1.03,skewX:4.3,x:-47.3},0).wait(6).to({scaleY:1.03,skewX:5.8,x:-46.5},0).wait(2).to({scaleY:1.03,skewX:7.5,x:-45.6},0).wait(2).to({scaleY:1.04,skewX:9.2,x:-44.8},0).wait(60).to({scaleY:1,skewX:8,x:-45.4,y:28.5},0).wait(2).to({scaleY:0.97,skewX:7,x:-46,y:29.5},0).wait(2).to({scaleY:0.93,skewX:6,x:-46.7,y:30.5},0).wait(2).to({scaleY:0.98,skewX:3.8,x:-47.7,y:29},0).wait(2).to({scaleY:1.03,skewX:1.8,x:-48.6,y:27.4},0).wait(2).to({scaleY:1.08,skewX:0,x:-49.6,y:25.9},0).wait(337).to({scaleY:1,y:28.2},0).wait(2).to({scaleY:0.98,y:28.9},0).wait(2).to({scaleY:1.03,y:27.4},0).wait(2).to({scaleY:1.08,y:25.9},0).wait(2).to({scaleY:1.07,skewX:2.8,x:-48,y:26.2},0).wait(2).to({scaleY:1.07,skewX:5.8,x:-46.5,y:26.6},0).wait(2).to({scaleY:1.06,skewX:8.8,x:-44.9,y:26.9},0).wait(2).to({scaleX:1.1,scaleY:1.06,x:-44.7},0).wait(2).to({scaleX:1.11,scaleY:1.06,skewX:9,x:-44.5},0).wait(2).to({scaleX:1.13,scaleY:1.06,skewX:9.1,x:-44.2},0).wait(2).to({scaleX:1.11,scaleY:1.06,skewX:9,x:-44.5},0).wait(2).to({scaleX:1.1,scaleY:1.06,skewX:8.8,x:-44.7},0).wait(2).to({scaleX:1.08,scaleY:1.06,x:-44.9},0).wait(2).to({scaleX:1.1,scaleY:1.06,x:-44.7,y:26.8},0).wait(2).to({scaleX:1.12,scaleY:1.06,skewX:9,x:-44.4,y:26.9},0).wait(2).to({scaleX:1.14,scaleY:1.06,skewX:9.2,x:-44.1},0).wait(2).to({scaleX:1.12,scaleY:1.06,skewX:9,x:-44.4},0).wait(2).to({scaleX:1.1,scaleY:1.06,skewX:8.8,x:-44.7,y:26.8},0).wait(2).to({scaleX:1.08,scaleY:1.06,x:-44.9,y:26.9},0).wait(24).to({scaleY:1.11,skewX:8.6,x:-44.7,y:25.7},0).wait(2).to({scaleY:1.15,x:-44.6,y:24.4},0).wait(2).to({scaleY:1.12,skewX:4.3,x:-47.1,y:25.2},0).wait(2).to({scaleY:1.08,skewX:0,x:-49.6,y:25.9},0).wait(2).to({scaleY:1.03,skewX:-1.3,x:-50.2,y:27.4},0).wait(2).to({scaleY:1.06,skewX:-0.5,x:-49.9,y:26.7},0).wait(2).to({scaleY:1.08,skewX:0,x:-49.6,y:25.9},0).wait(66).to({scaleY:1,y:28.2},0).wait(2).to({scaleY:0.98,y:28.9},0).wait(2).to({scaleY:1.03,y:27.4},0).wait(2).to({scaleY:1.08,y:25.9},0).wait(2).to({scaleY:1.07,skewX:2.8,x:-48,y:26.2},0).wait(2).to({scaleY:1.07,skewX:5.8,x:-46.5,y:26.6},0).wait(2).to({scaleY:1.06,skewX:8.8,x:-44.9,y:26.9},0).wait(2).to({scaleX:1.1,scaleY:1.06,x:-44.7},0).wait(2).to({scaleX:1.11,scaleY:1.06,skewX:9,x:-44.5},0).wait(2).to({scaleX:1.13,scaleY:1.06,skewX:9.1,x:-44.2},0).wait(2).to({scaleX:1.11,scaleY:1.06,skewX:9,x:-44.5},0).wait(2).to({scaleX:1.1,scaleY:1.06,skewX:8.8,x:-44.7},0).wait(2).to({scaleX:1.08,scaleY:1.06,x:-44.9},0).wait(4).to({scaleY:1.11,skewX:8.6,x:-44.7,y:25.7},0).wait(2).to({scaleY:1.15,x:-44.6,y:24.4},0).wait(2).to({scaleY:1.12,skewX:4.3,x:-47.1,y:25.2},0).wait(2).to({scaleY:1.08,skewX:0,x:-49.6,y:25.9},0).wait(2).to({scaleY:1.03,skewX:-1.3,x:-50.2,y:27.4},0).wait(2).to({scaleY:1.06,skewX:-0.5,x:-49.9,y:26.7},0).wait(2).to({scaleY:1.08,skewX:0,x:-49.6,y:25.9},0).to({_off:true},4).wait(31));

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-114.9,-40.3,195.3,112.7);


(lib.pig = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// noseGlow
	this.noseGlow = new lib.pig_noseGlow();
	this.noseGlow.parent = this;
	this.noseGlow.setTransform(168.3,196.6,1,1,0,0,0,12.2,11.9);
	this.noseGlow.alpha = 0;
	this.noseGlow.filters = [new cjs.BlurFilter(4, 4, 1)];
	this.noseGlow.cache(-4,-1,32,29);

	this.timeline.addTween(cjs.Tween.get(this.noseGlow).wait(1));

	// tummyGlow
	this.tummyGlow = new lib.pig_tummyGlow();
	this.tummyGlow.parent = this;
	this.tummyGlow.setTransform(274.5,178.9,1,1,0,0,0,50.4,19.2);
	this.tummyGlow.alpha = 0;
	this.tummyGlow.filters = [new cjs.BlurFilter(4, 4, 1)];
	this.tummyGlow.cache(-4,-4,109,46);

	this.timeline.addTween(cjs.Tween.get(this.tummyGlow).wait(1));

	// backGlow
	this.backGlow = new lib.pig_backGlow();
	this.backGlow.parent = this;
	this.backGlow.setTransform(272.6,142,1,1,0,0,0,60.6,18.9);
	this.backGlow.alpha = 0;
	this.backGlow.filters = [new cjs.BlurFilter(4, 4, 1)];
	this.backGlow.cache(-4,-4,129,46);

	this.timeline.addTween(cjs.Tween.get(this.backGlow).wait(1));

	// legGlow
	this.legGlow = new lib.pig_legGlow();
	this.legGlow.parent = this;
	this.legGlow.setTransform(327.3,186.8,1,1,0,0,0,21.4,48.8);
	this.legGlow.alpha = 0;
	this.legGlow.filters = [new cjs.BlurFilter(4, 4, 1)];
	this.legGlow.cache(-104,-4,151,107);

	this.timeline.addTween(cjs.Tween.get(this.legGlow).wait(1));

	// tail
	this.leg2 = new lib.invisiblebox();
	this.leg2.parent = this;
	this.leg2.setTransform(327.4,199.9,1.729,0.951,-89.8);

	this.leg1 = new lib.invisiblebox();
	this.leg1.parent = this;
	this.leg1.setTransform(225.8,200.6,1.589,0.602,-83.2);

	this.neck = new lib.invisiblebox();
	this.neck.parent = this;
	this.neck.setTransform(203.4,150.4,0.65,0.744,-19.2);

	this.tummy = new lib.invisiblebox();
	this.tummy.parent = this;
	this.tummy.setTransform(276.2,184,1.38,0.868,-2.8);

	this.ear = new lib.invisiblebox();
	this.ear.parent = this;
	this.ear.setTransform(172.5,162.5,0.773,0.712,0,90.7,81.1);

	this.nose = new lib.invisiblebox();
	this.nose.parent = this;
	this.nose.setTransform(176.9,198.7,1.198,0.65,0.2);

	this.back = new lib.invisiblebox();
	this.back.parent = this;
	this.back.setTransform(273.6,136.2,2.291,0.686,0.2);

	this.tail = new lib.invisiblebox();
	this.tail.parent = this;
	this.tail.setTransform(358.2,148.9,0.652,0.594,-23);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.tail},{t:this.back},{t:this.nose},{t:this.ear},{t:this.tummy},{t:this.neck},{t:this.leg1},{t:this.leg2}]}).wait(1));

	// main
	this.instance = new lib.PigTorso_bubbles();
	this.instance.parent = this;
	this.instance.setTransform(275.2,160.6,1.292,1.292,0,0,180);
	this.instance.shadow = new cjs.Shadow("rgba(0,0,0,1)",0,1,3);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	// main
	this.main = new lib.Pig();
	this.main.parent = this;
	this.main.setTransform(-234.9,-13.3,1.194,1.194,0,0,0,20.6,55.5);

	this.timeline.addTween(cjs.Tween.get(this.main).wait(1));

}).prototype = getMCSymbolPrototype(lib.pig, new cjs.Rectangle(-396.7,-127.7,771.5,372.1), null);


// stage content:
(lib.MWpig = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = null;
// library properties:
lib.properties = {
	width: 600,
	height: 307,
	fps: 30,
	color: "#FFFFFF",
	opacity: 1.00,
	manifest: [
		{src:"../../../deploy/assets/images/MWpig_atlas_.png?1528311082083", id:"MWpig_atlas_"}
	],
	preloads: []
};




})(lib_Pig = lib_Pig||{}, images = images||{}, createjs = createjs||{}, ss = ss||{}, AdobeAn = AdobeAn||{});
var lib_Pig, images, createjs, ss, AdobeAn;